var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStuga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 1366 393",
    enableBackground: "new 0 0 1366 393",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M419.000000,255.500000  C417.844666,264.982666 418.595856,274.501556 418.544647,284.000244  C418.411713,308.666168 418.500000,333.333344 418.500000,358.250000  C486.332520,358.250000 554.166260,358.250000 622.500000,358.250000  C622.500000,353.845245 622.674377,349.164734 622.463684,344.501648  C622.025269,334.798798 623.213501,325.168274 623.500000,315.500000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1285.500000,197.000000  C1285.342407,211.666672 1286.524536,226.333328 1285.200439,241.250000  C1289.318848,241.250000 1293.159424,241.250000 1297.250000,241.250000  C1297.250000,198.001282 1297.250000,154.500641 1297.250000,110.750000  C1282.003540,110.750000 1266.501831,110.750000 1250.750000,110.750000  C1250.750000,153.998718 1250.750000,197.499359 1250.750000,241.250000  C1261.995117,241.250000 1273.497559,241.250000 1285.250000,241.250000  C1285.250000,261.497223 1285.250000,281.498596 1285.250000,301.500000  C1288.666626,301.500000 1291.833374,301.500000 1295.604492,301.500000  C1295.168945,303.500000 1296.103638,305.500000 1295.000000,307.500000  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1235.000000,241.500000  C1239.333374,241.500000 1243.666626,241.500000 1248.250000,241.500000  C1248.250000,198.001282 1248.250000,154.500641 1248.250000,110.750000  C1232.670166,110.750000 1216.835083,110.750000 1201.000000,110.750000  C1201.000000,153.998718 1201.000000,197.499359 1201.000000,241.500000  C1211.661743,241.500000 1222.830811,241.500000 1234.000000,241.500000  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1326.500000,83.500000  C1326.500000,99.833336 1326.509277,116.166679 1326.486938,132.499985  C1326.484375,134.291733 1327.145264,136.611603 1323.250000,136.478683  C1323.250000,110.833336 1323.250000,85.156929 1323.250000,59.480518  C1320.860107,60.709652 1321.538208,62.482643 1321.533569,64.000099  C1321.480957,81.499939 1321.521606,99.000069 1321.464600,116.499886  C1321.459229,118.157066 1322.058716,119.922539 1321.000000,121.500000  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1320.000000,253.000000  C1320.542480,248.647552 1318.676392,243.924576 1321.756470,239.618668  C1323.859253,242.911957 1324.309326,311.765594 1322.351318,316.889191  C1320.860107,315.290344 1321.538208,313.517365 1321.533569,311.999908  C1321.480957,294.500061 1321.521729,276.999939 1321.464600,259.500122  C1321.459229,257.842926 1322.058716,256.077454 1321.000000,254.500000  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M748.000000,126.500000  C746.941284,128.077469 747.536072,129.843414 747.534241,131.500031  C747.490234,171.499985 747.518799,211.500046 747.419006,251.499802  C747.415649,252.847260 749.207520,255.687073 745.500000,255.500000  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M981.000000,126.500000  C979.941284,128.077469 980.536072,129.843414 980.534241,131.500031  C980.490234,171.499985 980.518799,211.500046 980.419006,251.499802  C980.415649,252.847260 982.207520,255.687073 978.500000,255.500000  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M776.000000,75.000000  C777.234863,83.464645 776.913818,92.057579 776.793396,100.497055  C776.075439,150.833130 776.798828,201.167068 776.509705,251.500061  C776.443665,262.999664 776.536255,274.500244 776.459839,285.999725  C776.448669,287.674927 777.329895,289.632660 775.500000,291.000000  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.000000,104.500000  C819.825562,113.147285 820.545776,121.834297 820.531555,130.500046  C820.461853,172.999939 820.500000,215.500000 820.500000,258.000000  C820.500000,272.333344 820.500000,286.666656 820.500000,301.047913  C819.294067,302.185913 817.785583,300.951233 816.403442,301.812958  C816.227478,301.022125 816.022034,300.512573 816.013489,299.999786  C815.829102,288.833405 815.631836,277.666992 815.527527,266.499756  C815.505127,264.096741 813.830872,261.976532 814.500000,259.500000  "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M900.000000,76.000000  C900.944824,88.489624 900.400879,100.999199 900.492981,113.500053  C900.534729,119.166405 900.500000,124.833336 900.500000,130.500000  C900.500000,173.000000 900.500000,215.500000 900.500000,258.000000  C900.500000,272.333344 900.500000,286.666656 900.500000,301.152985  C898.739258,301.773804 897.050537,301.827972 895.500000,300.500000  "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1059.000000,75.000000  C1060.234863,83.464645 1059.916382,92.058037 1059.793091,100.496979  C1059.055786,150.999817 1059.799683,201.500381 1059.514404,252.000076  C1059.422119,268.332916 1059.500000,284.666656 1059.500000,301.020905  C1058.276245,302.043549 1056.806641,301.119781 1055.377930,301.698547  C1055.227417,301.022125 1055.021851,300.512604 1055.013428,299.999786  C1054.828857,288.833405 1054.631958,277.666992 1054.527710,266.499756  C1054.505249,264.096741 1052.830933,261.976532 1053.500000,259.500000  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1139.000000,76.000000  C1139.944824,88.489624 1139.400879,100.999199 1139.492920,113.500053  C1139.534668,119.166405 1139.500000,124.833336 1139.500000,130.500000  C1139.500000,173.000000 1139.500000,215.500000 1139.500000,258.000000  C1139.500000,272.333344 1139.500000,286.666656 1139.500000,301.152985  C1137.739258,301.773804 1136.050537,301.827972 1134.500000,300.500000  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M519.500000,221.500000  C519.803040,223.136368 519.146057,223.615234 517.498474,223.530014  C505.476349,222.908249 493.484344,225.668579 481.510742,224.398819  C463.838959,222.524796 446.102722,224.790771 428.521790,223.251190  C417.864624,222.317932 407.515930,224.837540 397.000000,224.000000  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1225.500000,315.000000  C1224.105469,313.884430 1222.488647,314.536713 1221.000000,314.534637  C1188.666626,314.489166 1156.333374,314.521790 1124.000000,314.473572  C1119.749268,314.467224 1115.793335,316.555695 1111.500000,316.000000  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1001.500000,61.000000  C1003.077454,59.941299 1004.843567,60.534775 1006.500000,60.533863  C1078.000000,60.494549 1149.500000,60.495327 1221.000000,60.510727  C1225.666626,60.511730 1230.333374,60.666668 1235.000000,60.750000  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M588.500000,22.000000  C584.309998,21.982512 583.995239,24.851027 583.995789,28.000000  C584.002319,65.000000 583.999390,102.000000 584.020691,138.999985  C584.020752,139.166748 584.333313,139.333344 584.500000,139.500000  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M588.500000,31.000000  C588.500000,68.333336 588.500000,105.666664 588.500000,143.250000  C620.998291,143.250000 653.499146,143.250000 686.500000,143.250000  C686.500000,104.668098 686.500000,65.834045 686.500000,26.750000  C654.001709,26.750000 621.500854,26.750000 588.671753,26.750000  C587.666565,27.583302 589.346008,29.419844 588.000000,30.500000  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M766.500000,51.500000  C768.762939,52.651768 771.171143,51.967094 773.500061,51.969994  C808.333313,52.013371 843.166687,52.000000 878.000000,52.000000  C916.666687,52.000000 955.333801,51.875397 993.999878,52.034969  C1032.833130,52.195225 1071.670898,52.249146 1110.500000,52.246635  C1149.329102,52.244125 1188.166870,52.234158 1227.000122,52.030254  C1256.166016,51.877110 1285.333374,52.005081 1314.500000,51.987129  C1316.213257,51.986076 1318.058716,52.460384 1319.500000,51.000000  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M994.500000,324.000000  C994.500000,323.666656 994.520325,323.331909 994.496704,323.000244  C994.336365,320.749786 994.166687,318.500000 994.000000,316.250000  C997.753235,316.210724 1000.991394,313.064178 1005.012817,314.463074  C1005.756226,314.721649 1006.666687,314.500000 1007.500000,314.500000  C1041.000000,314.500000 1074.500732,314.592377 1107.998413,314.308807  C1110.441162,314.288147 1111.183228,315.326416 1110.856201,316.458496  C1110.115967,319.021698 1110.838745,321.511475 1110.500000,324.000000  "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M878.000000,61.000000  C876.500000,60.833332 875.000122,60.522388 873.500000,60.521179  C839.333313,60.493664 805.166687,60.496429 771.000000,60.521107  C770.166870,60.521709 769.180908,60.071190 768.500000,61.000000  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M766.500000,49.500000  C770.500000,47.977592 774.498901,49.568443 778.500183,49.556145  C810.999878,49.456238 843.500000,49.500000 876.000000,49.500000  C914.666687,49.500000 953.333313,49.500000 992.000000,49.500000  C1031.000000,49.500000 1070.000000,49.500000 1109.000000,49.500000  C1147.666626,49.500000 1186.333374,49.500000 1225.000000,49.500000  C1244.000000,49.500000 1263.000122,49.472813 1281.999756,49.560493  C1283.281250,49.566410 1285.850952,48.177601 1285.500000,51.500000  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M45.000000,45.500000  C47.620026,43.973797 48.345764,44.292534 48.461311,47.501392  C48.617149,51.829113 48.500000,56.166668 48.500000,60.500000  C83.833336,60.500000 119.166672,60.492359 154.499985,60.518303  C156.704330,60.519920 158.775681,60.674175 157.000000,57.500000  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M766.500000,326.000000  C769.099060,327.248199 771.839478,326.434662 774.500366,326.463348  C808.832397,326.834259 843.173035,326.808685 877.499573,326.748871  C916.330566,326.681213 955.167358,326.574463 994.000000,326.570862  C1032.832642,326.567291 1071.670654,326.737823 1110.500122,326.748749  C1148.995605,326.759613 1187.500122,326.721100 1226.000122,326.529816  C1255.999390,326.380768 1286.000000,326.520660 1315.999878,326.456940  C1318.167236,326.452332 1320.333374,325.833344 1322.500000,325.500000  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M766.500000,325.000000  C768.883728,323.794861 771.458252,324.002960 774.000000,324.002655  C807.000000,323.998657 840.000000,324.000000 873.000000,324.000000  C907.500000,324.000000 942.005188,323.620911 976.498718,324.094635  C1021.000916,324.705780 1065.499878,324.356781 1110.000000,324.478638  C1147.833130,324.582214 1185.666626,324.500000 1223.500000,324.500000  C1253.500000,324.500000 1283.500000,324.487152 1313.500000,324.534576  C1315.156738,324.537201 1316.922485,323.941315 1318.500000,325.000000  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M876.500000,315.000000  C875.105408,313.884430 873.488586,314.536713 871.999939,314.534607  C839.666687,314.489166 807.333313,314.500000 775.000000,314.500000  C774.166687,314.500000 773.263123,314.286987 772.511414,314.534576  C767.628052,316.143158 763.215027,317.187592 761.861328,310.026215  C761.587463,308.577606 759.333069,307.836365 757.501038,308.010773  C745.512878,309.152039 733.498901,308.232117 721.499146,308.452057  C718.604370,308.505096 715.906677,308.793427 713.500000,310.500000  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M992.500000,315.000000  C990.922546,313.941315 989.156677,314.537079 987.499939,314.534546  C956.666687,314.487488 925.832947,314.572327 895.000366,314.427826  C889.939941,314.404144 884.502014,314.192871 880.115295,315.812347  C872.162109,318.748505 864.323181,317.300232 856.498779,317.380920  C827.501831,317.679993 798.500000,317.500000 769.421814,317.500000  C769.832458,319.486176 768.933899,321.574951 770.000000,323.500000  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M993.000000,317.500000  C957.166687,317.500000 921.333313,317.500000 885.421814,317.500000  C885.832458,319.486176 884.933899,321.574951 886.000000,323.500000  "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M277.500000,44.000000  C280.166595,43.222317 281.605194,43.917641 281.528656,47.000710  C281.417023,51.497940 281.500000,56.000000 281.500000,60.500000  C316.000000,60.500000 350.500031,60.484409 384.999939,60.539917  C387.004089,60.543140 389.246185,59.689510 391.000000,61.500000  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M164.000000,61.500000  C165.753815,59.689510 167.995926,60.543140 170.000061,60.539917  C204.499969,60.484413 239.000000,60.500000 273.750000,60.500000  C273.750000,54.994961 273.750000,49.489929 273.750000,43.987282  C275.219238,44.061531 276.712067,43.575867 277.000000,45.500000  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1109.500000,317.500000  C1073.833374,317.500000 1038.166626,317.500000 1002.500000,317.500000  C1002.500000,319.666656 1002.500000,321.833344 1002.500000,324.000000  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1294.000000,311.500000  C1293.367920,314.224335 1291.521851,314.574066 1288.999634,314.556519  C1273.000366,314.445251 1256.997192,314.331268 1241.001709,314.598694  C1235.934326,314.683350 1230.758667,315.156891 1225.964111,317.424225  C1224.874512,317.939514 1223.333374,317.500000 1222.000000,317.500000  C1187.500000,317.500000 1153.000000,317.500000 1118.500000,317.500000  C1118.500000,319.666656 1118.500000,321.833344 1118.500000,324.000000  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1225.500000,62.000000  C1224.646240,63.043800 1223.487183,62.468044 1222.500000,62.469143  C1189.166626,62.506310 1155.833374,62.506310 1122.500000,62.469143  C1121.512817,62.468044 1120.353760,63.043800 1119.500000,62.000000  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M694.000000,25.500000  C695.227417,31.637999 694.031494,37.841492 694.654541,44.500000  C720.664551,44.500000 746.832275,44.500000 773.000000,44.500000  "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1326.000000,140.500000  C1327.043823,141.353806 1326.467773,142.512787 1326.469116,143.500046  C1326.507080,173.166656 1326.507202,202.833344 1326.469116,232.499954  C1326.467896,233.487213 1327.043823,234.646194 1326.000000,235.500000  "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M645.500000,224.000000  C640.884827,222.391647 636.542297,221.431610 631.409851,223.244904  C627.705566,224.553619 623.166626,223.486847 619.000000,223.502441  C605.992859,223.551147 592.999268,223.541199 579.991760,224.370804  C569.866272,225.016586 559.666687,224.500000 549.500000,224.500000  "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1140.500000,100.500000  C1170.333374,100.500000 1200.166626,100.500000 1230.156860,100.500000  C1231.151733,103.447144 1230.631104,104.603706 1226.999512,104.584587  C1198.166992,104.432724 1169.333374,104.500000 1140.500000,104.500000  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1140.500000,277.500000  C1170.333374,277.500000 1200.166626,277.500000 1230.047241,277.500000  C1231.043213,276.458557 1230.221069,275.150635 1230.663696,273.500000  C1200.501831,273.500000 1170.500977,273.500000 1140.500000,273.500000  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M773.000000,48.500000  C774.014587,39.833332 773.319519,31.166666 773.553406,22.000000  C768.846680,22.000000 764.673035,22.031483 760.500061,21.994505  C743.166626,21.840912 725.828247,21.379709 708.503296,21.686886  C703.732300,21.771479 698.662903,20.852386 694.000000,23.000000  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M469.500000,83.500000  C463.570953,85.672073 461.036438,80.129318 457.052734,77.893158  C454.753387,82.552834 454.423889,154.053970 456.500000,186.500000  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M375.000000,71.500000  C377.501160,77.435150 375.296661,83.512856 375.369019,89.501579  C375.677155,114.997856 375.491699,140.500000 375.505524,166.000000  C375.509216,172.847656 375.113922,179.718018 376.500000,186.500000  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M216.000000,71.500000  C216.940308,83.656067 216.406158,95.833275 216.473297,108.000145  C216.575363,126.499580 216.470154,145.000076 216.514313,163.499969  C216.532639,171.176788 215.988419,178.884567 217.500000,186.500000  "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M140.000000,181.500000  C141.058701,179.922531 140.462463,178.156738 140.465347,176.499939  C140.513840,148.666702 140.497391,120.833336 140.505005,93.000000  C140.505600,90.787971 140.578888,88.657639 141.431580,86.473289  C143.493073,81.192314 143.350723,81.136742 138.003799,78.001175  C135.464096,79.591515 136.111572,82.542252 136.168457,84.495094  C137.076523,115.663483 136.233780,146.833847 136.411957,178.000504  C136.428772,180.944962 137.943832,183.575241 137.500000,186.500000  "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M59.500000,83.000000  C58.526394,91.818108 59.058788,100.666779 59.027290,109.500099  C58.945869,132.333130 58.975243,155.166733 59.029434,177.999924  C59.036701,181.062073 58.847885,184.057175 58.000000,187.000000  "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M297.000000,78.000000  C298.988678,81.862053 297.992340,85.976028 297.993896,90.000000  C298.005219,119.333336 297.980469,148.666702 298.029083,177.999954  C298.034149,181.061935 297.847900,184.057175 297.000000,187.000000  "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M515.750000,92.000000  C514.295532,90.592781 514.549255,88.774796 514.485352,87.000526  C514.308777,82.095116 512.188538,80.003357 507.500000,80.000000  C503.069397,79.996834 500.650513,82.231133 500.542328,87.000961  C500.379822,94.163940 500.500000,101.333336 500.500000,108.500000  C500.500000,129.333328 500.531403,150.166748 500.477203,170.999939  C500.464172,176.000336 500.166656,181.000000 500.000000,186.000000  "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1109.500000,62.000000  C1107.922485,63.058701 1106.156860,62.461380 1104.499878,62.465096  C1081.500000,62.516674 1058.500000,62.483322 1035.500122,62.534901  C1033.843140,62.538612 1032.077515,61.941299 1030.500000,63.000000  "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M556.500000,85.000000  C556.500000,116.166664 556.487549,147.333344 556.534424,178.499954  C556.536926,180.156677 555.941284,181.922531 557.000000,183.500000  "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M375.000000,104.500000  C349.500000,104.500000 324.000000,104.500000 298.500000,104.500000  "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M136.000000,104.500000  C110.500000,104.500000 85.000000,104.500000 59.500000,104.500000  "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M375.000000,100.500000  C349.500000,100.500000 324.000000,100.500000 298.500000,100.500000  "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M136.000000,100.500000  C110.500000,100.500000 85.000000,100.500000 59.500000,100.500000  "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M461.000000,85.500000  C459.386932,87.777390 459.494720,90.392937 459.495422,93.000000  C459.502838,120.833336 459.513855,148.666702 459.465363,176.499939  C459.462463,178.156738 460.058685,179.922531 459.000000,181.500000  "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M377.000000,78.000000  C382.350708,81.136749 382.493073,81.192314 380.431580,86.473297  C379.578888,88.657639 379.505615,90.787971 379.505005,93.000000  C379.497375,120.833336 379.513824,148.666702 379.465332,176.499939  C379.462433,178.156738 380.058685,179.922531 379.000000,181.500000  "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M669.000000,232.000000  C662.189453,230.899841 655.331909,231.743332 648.499634,231.511292  C638.836487,231.183105 629.167542,231.876266 619.490173,231.127060  C616.398682,230.887726 613.191223,232.145065 609.500000,232.815033  C609.500000,238.156860 609.500000,243.828430 609.500000,249.500000  "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M975.500000,223.500000  C975.500000,232.833328 975.546997,242.167068 975.467590,251.499725  C975.447205,253.891418 975.572510,256.149261 974.221252,258.620941  C973.009705,260.837036 974.633911,263.853973 975.403687,266.527740  C977.176208,272.684265 976.381470,273.497986 970.000000,273.498810  C947.166687,273.501862 924.333313,273.500000 901.500000,273.500000  "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M483.500000,60.000000  C483.283142,58.505577 483.990509,56.908459 482.951782,55.250000  C462.000000,55.250000 441.000000,55.250000 420.048218,55.250000  C419.009491,56.908459 419.716858,58.505577 419.500000,60.000000  "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M221.500000,144.500000  C245.166672,144.500000 268.833344,144.500000 292.500000,144.500000  "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M901.500000,277.500000  C923.500000,277.500000 945.500061,277.482605 967.499939,277.535004  C969.156860,277.538940 970.922546,276.941315 972.500000,278.000000  "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1135.000000,154.500000  C1136.058716,156.077469 1135.460083,157.843018 1135.464844,159.500107  C1135.519775,178.833267 1135.519775,198.166733 1135.464844,217.499893  C1135.460083,219.156982 1136.058716,220.922531 1135.000000,222.500000  "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M773.000000,154.500000  C774.058716,156.077469 773.460205,157.843018 773.464905,159.500107  C773.519775,178.833267 773.519775,198.166733 773.464905,217.499893  C773.460205,219.156982 774.058716,220.922531 773.000000,222.500000  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M743.000000,154.500000  C744.058716,156.077469 743.460205,157.843018 743.464905,159.500107  C743.519775,178.833267 743.519775,198.166733 743.464905,217.499893  C743.460205,219.156982 744.058716,220.922531 743.000000,222.500000  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M896.000000,154.500000  C897.058716,156.077469 896.460205,157.843018 896.464905,159.500107  C896.519775,178.833267 896.519775,198.166733 896.464905,217.499893  C896.460205,219.156982 897.058716,220.922531 896.000000,222.500000  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M713.000000,154.500000  C714.058716,156.077469 713.460205,157.843018 713.464905,159.500107  C713.519775,178.833267 713.519775,198.166733 713.464905,217.499893  C713.460205,219.156982 714.058716,220.922531 713.000000,222.500000  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M976.000000,154.500000  C977.058716,156.077469 976.460205,157.843018 976.464905,159.500107  C976.519775,178.833267 976.519775,198.166733 976.464905,217.499893  C976.460205,219.156982 977.058716,220.922531 976.000000,222.500000  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.500000,124.500000  C1080.833374,124.500000 1101.166626,124.481201 1121.499878,124.535072  C1123.156982,124.539474 1124.922485,123.941299 1126.500000,125.000000  "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.500000,124.500000  C841.833313,124.500000 862.166748,124.481201 882.499878,124.535072  C884.156921,124.539467 885.922546,123.941299 887.500000,125.000000  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.500000,126.500000  C841.833313,126.500000 862.166748,126.518799 882.499878,126.464928  C884.156921,126.460541 885.922546,127.058701 887.500000,126.000000  "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.500000,126.500000  C1080.833374,126.500000 1101.166626,126.518806 1121.499878,126.464935  C1123.156982,126.460541 1124.922485,127.058701 1126.500000,126.000000  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M693.000000,24.000000  C691.519226,23.931084 691.694946,25.257792 691.543945,26.008842  C690.278931,32.299767 691.010925,38.679958 691.174866,44.995461  C691.234802,47.302780 692.959900,49.794205 696.518555,49.094494  C697.748169,48.852730 699.989990,47.931164 700.109741,50.995712  C700.157043,52.207150 701.866516,52.009228 703.000000,52.008564  C723.166687,51.996758 743.333313,51.997807 763.500000,52.007397  C764.378296,52.007816 765.252930,52.098011 766.046082,51.050442  C766.187012,49.983704 766.021790,48.936832 763.999512,48.971493  C742.834839,49.334194 721.658997,48.361084 700.500000,49.500000  "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M583.000000,28.500000  C580.974731,28.141386 580.399292,28.967094 580.459412,31.001200  C580.956848,47.832409 579.569092,64.636208 580.314331,81.508202  C581.130005,99.972168 580.500000,118.500000 580.500000,137.000000  C580.500000,138.333328 580.500000,139.666672 580.499756,140.998749  C583.428284,143.276367 584.741272,138.014832 587.500000,139.500000  "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M685.000000,306.500000  C679.839783,308.551575 674.606018,308.910339 668.992554,308.686371  C659.354919,308.301880 649.661438,308.009766 639.993408,308.930664  C637.035889,309.212372 633.999817,308.669952 630.370728,308.470337  C630.852661,313.166656 629.890198,317.833344 631.000000,322.500000  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M394.000000,45.500000  C396.620026,43.973801 397.345764,44.292538 397.461334,47.501392  C397.617157,51.829113 397.500000,56.166668 397.500000,60.500000  C433.833344,60.500000 470.166656,60.500000 506.430084,60.500000  C506.800171,55.004047 506.026886,49.475563 506.997681,43.999222  C509.333344,42.915451 511.666656,43.697636 514.211609,44.120708  C515.043640,49.500000 513.940796,55.000000 514.000000,60.500000  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M477.500000,225.000000  C474.211914,226.071640 470.829712,225.448410 467.499817,225.464737  C451.500214,225.543198 435.499908,225.523666 419.500122,225.464539  C417.842834,225.458420 416.077454,226.058701 414.500000,225.000000  "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M475.500000,250.000000  C459.666656,250.000000 443.831909,250.125854 428.000610,249.945236  C420.436707,249.858948 412.984344,250.703461 405.493134,251.429291  C402.702148,251.699722 399.833344,251.166672 397.000000,251.000000  "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M414.000000,252.000000  C422.268768,255.615051 431.006409,253.884186 439.493896,253.707382  C442.178497,253.651443 445.169464,253.100082 448.000885,253.054779  C457.165192,252.908096 466.333344,253.000000 475.500000,253.000000  "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1140.000000,114.500000  C1160.000000,114.500000 1180.000000,114.500000 1200.000000,114.500000  "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1140.500000,126.500000  C1160.333374,126.500000 1180.166626,126.500000 1200.000000,126.500000  "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1140.500000,124.500000  C1160.333374,124.500000 1180.166626,124.500000 1200.000000,124.500000  "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M670.500000,321.000000  C671.073669,319.116394 672.947083,320.483673 674.048828,319.558167  C675.393799,318.428467 677.274292,317.540741 676.404724,315.541443  C675.791138,314.130768 674.460022,312.969238 672.499878,312.977295  C661.166809,313.023834 649.833252,313.014771 638.500061,312.986908  C636.344299,312.981628 635.113281,314.140594 634.526184,316.008240  C633.859131,318.130157 635.751404,318.548859 636.949402,319.559967  C638.049683,320.488586 639.926331,319.116394 640.500000,321.000000  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1140.500000,112.500000  C1160.333374,112.500000 1180.166626,112.500000 1200.000000,112.500000  "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M686.000000,256.000000  C684.543823,253.728302 682.630188,255.583298 680.999573,255.573135  C662.500244,255.457886 644.000000,255.502625 625.500000,255.479187  C625.166504,255.478760 624.833313,255.166672 624.500000,255.000000  "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.000000,114.500000  C841.500000,114.500000 862.000061,114.485146 882.499939,114.534515  C883.821167,114.537689 885.278076,113.941986 886.500000,115.000000  "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M380.500000,100.500000  C405.333344,100.500000 430.166656,100.500000 455.000000,100.500000  "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M380.500000,104.500000  C405.333344,104.500000 430.166656,104.500000 455.000000,104.500000  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1226.500000,273.000000  C1226.500000,261.333344 1226.497070,249.666672 1226.501099,238.000000  C1226.503418,231.441940 1227.369263,230.753448 1234.500000,232.093994  C1234.500000,256.831085 1234.500000,281.665558 1234.500000,306.500000  "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M687.500000,323.000000  C685.723511,325.190887 683.230774,324.571533 681.002258,324.456665  C673.164124,324.052704 665.372681,323.131531 657.504395,322.868347  C647.635071,322.538269 637.820435,322.382263 627.995361,323.457550  C626.695862,323.599792 625.333313,323.166656 624.000000,323.000000  "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.500000,277.500000  C838.500000,277.500000 855.500061,277.477692 872.499878,277.535400  C874.157104,277.541016 875.922546,276.941315 877.500000,278.000000  "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M818.000000,70.500000  C818.336914,68.370529 816.808105,68.511131 815.500000,68.509598  C802.166687,68.493896 788.833313,68.494576 775.500061,68.521095  C774.999695,68.522087 774.490051,69.003799 774.001465,68.975204  C759.499634,68.126511 744.997498,68.843636 730.501343,68.763161  C725.272583,68.734146 720.078979,69.902214 715.024475,69.296013  C710.352051,68.735634 705.741211,67.880852 700.999634,67.982323  C696.076233,68.087677 694.755066,69.126663 694.538757,74.001717  C694.367615,77.857361 694.586304,81.706863 693.537659,85.510391  C692.487976,89.317719 695.193420,92.654205 695.099060,96.502426  C694.821411,107.828957 695.000000,119.166664 695.000000,130.500000  C695.000000,151.333328 695.000000,172.166672 695.000000,193.000000  "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.500000,273.500000  C844.500000,273.500000 867.500000,273.506165 890.500000,273.495728  C896.385681,273.493073 897.046021,273.033813 895.382507,267.535553  C893.869385,262.534271 895.371704,257.837158 895.451538,252.999207  C895.613708,243.168549 895.500000,233.333328 895.500000,223.500000  "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M665.500000,225.500000  C665.784912,223.136276 663.982117,224.064041 662.998962,224.032028  C656.284973,223.813416 649.630432,225.066040 642.992920,225.298660  C625.847290,225.899536 608.666687,225.502823 591.500000,225.479156  C591.166504,225.478699 590.833313,225.166672 590.500000,225.000015  "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1325.000000,237.000000  C1328.330688,255.423492 1325.627930,274.010040 1326.500000,292.500000  "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M619.500000,255.000000  C612.689453,256.100159 605.832458,255.373505 598.999512,255.462402  C588.168030,255.603363 577.333313,255.500000 566.500000,255.500000  C566.500000,281.666656 566.500000,307.833344 566.500000,334.047272  C565.458557,335.043243 564.150635,334.221069 563.000000,334.529663  C563.000000,321.833344 563.000000,309.166656 563.000000,296.500000  "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M589.000000,21.000000  C606.451477,23.880423 623.986572,22.372116 641.500000,22.000000  "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M975.500000,57.000000  C974.072632,58.297626 972.365540,58.526115 970.499939,58.521423  C955.333374,58.483315 940.166687,58.504780 925.000061,58.478970  C924.499756,58.478119 924.000000,58.166668 923.500000,58.000000  "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M221.500000,104.500000  C245.166672,104.500000 268.833344,104.500000 292.500000,104.500000  "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1054.000000,100.500000  C1038.500000,100.500000 1022.999878,100.524406 1007.500122,100.464485  C1005.842834,100.458084 1004.077454,101.058701 1002.500000,100.000000  "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M221.500000,100.500000  C245.166672,100.500000 268.833344,100.500000 292.500000,100.500000  "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M981.500000,273.500000  C1005.666687,273.500000 1029.833374,273.500000 1054.000000,273.500000  "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M482.500000,120.000000  C482.500000,128.000000 482.394958,136.002136 482.557587,143.998825  C482.613678,146.757690 481.938507,148.105164 478.421753,147.269745  C478.857910,140.500000 477.863403,133.500000 479.000000,126.500000  "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M987.500000,104.500000  C1007.333313,104.500000 1027.166626,104.490578 1047.000000,104.509727  C1050.132080,104.512749 1053.404541,103.865425 1056.048706,106.450165  C1056.417114,106.810226 1057.556641,106.668259 1057.500000,105.500000  "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M924.500000,100.500000  C939.666687,100.500000 954.833313,100.491653 970.000000,100.511803  C971.674500,100.514023 973.396790,100.198730 975.000000,101.000000  "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M828.000000,104.500000  C849.666687,104.500000 871.333679,104.459244 892.998779,104.642059  C893.909485,104.649757 895.822388,104.358917 896.495239,106.072342  C894.779114,111.284767 896.122498,116.665329 896.003479,122.000076  C895.975342,123.260078 896.207886,124.583206 895.000000,125.500000  "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.000000,114.500000  C1081.000000,114.500000 1102.000000,114.512611 1122.999878,114.465950  C1124.152954,114.463387 1125.463013,115.074150 1126.500000,114.000000  "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M216.000000,104.500000  C191.166672,104.500000 166.333328,104.500000 141.500000,104.500000  "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M924.500000,104.500000  C940.666687,104.500000 956.833984,104.445404 972.998230,104.643341  C973.913147,104.654533 975.822388,104.358917 976.488831,106.056061  C974.989563,110.618675 976.242493,115.349274 975.863220,119.988815  C975.704102,121.935768 976.462708,124.304573 974.525818,126.028984  C973.328735,127.094711 973.705261,128.878311 974.090393,129.968048  C976.825806,137.707825 974.911987,145.672287 975.500000,153.500000  "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1052.500000,278.000000  C1043.183716,276.880066 1033.831299,277.591949 1024.499878,277.568298  C1017.170837,277.549713 1009.810791,276.840942 1002.500000,278.000000  "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M551.500000,250.000000  C536.666687,250.000000 521.833252,249.983795 507.000061,250.020370  C505.133698,250.024963 503.112518,249.452164 501.500000,251.000000  "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M828.000000,100.500000  C849.000000,100.500000 870.000000,100.498581 891.000000,100.501602  C893.987976,100.502037 897.295044,100.204964 895.500000,105.000000  "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M141.500000,100.500000  C166.333328,100.500000 191.166672,100.500000 216.000000,100.500000  "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.500000,104.500000  C1084.333374,104.500000 1108.166870,104.462944 1131.998901,104.641708  C1132.908569,104.648537 1134.822388,104.358917 1135.495239,106.072342  C1133.779175,111.284767 1135.122437,116.665329 1135.003296,122.000076  C1134.975220,123.260078 1135.207886,124.583206 1134.000000,125.500000  "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.500000,277.500000  C1082.500000,277.500000 1104.500000,277.482605 1126.499878,277.534973  C1128.156982,277.538940 1129.922485,276.941315 1131.500000,278.000000  "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.500000,100.500000  C1083.666626,100.500000 1106.833374,100.498703 1130.000000,100.501595  C1132.987915,100.501968 1136.295044,100.204964 1134.500000,105.000000  "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.500000,112.500000  C1080.833374,112.500000 1101.166626,112.481201 1121.499878,112.535072  C1123.156982,112.539467 1124.922485,111.941299 1126.500000,113.000000  "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M641.500000,148.000000  C628.846069,146.866379 616.165588,147.769012 603.499573,147.521301  C598.417236,147.421906 593.271118,147.116653 588.500000,149.500000  "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1060.500000,273.500000  C1083.500000,273.500000 1106.500000,273.506134 1129.500000,273.495728  C1135.385620,273.493042 1136.045898,273.033844 1134.382324,267.535583  C1132.869263,262.534302 1134.371826,257.837158 1134.451538,252.999207  C1134.613647,243.168549 1134.500000,233.333328 1134.500000,223.500000  "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M513.000000,61.500000  C514.575378,59.748001 516.655151,60.544472 518.500183,60.536488  C533.499878,60.471577 548.500000,60.500000 563.500000,60.500000  "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1286.000000,67.500000  C1288.666626,67.500000 1291.333374,67.500000 1294.110107,67.500000  C1295.009155,66.093605 1294.240723,64.489708 1294.564819,62.848202  C1294.022095,62.727436 1293.511230,62.514835 1293.000000,62.514320  C1275.833374,62.497059 1258.666504,62.522129 1241.500122,62.464653  C1239.842896,62.459103 1238.077515,63.058701 1236.500000,62.000000  "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1294.500000,307.500000  C1288.180664,306.799927 1281.901978,306.603394 1275.493896,306.824158  C1259.845947,307.363342 1244.166626,307.000000 1228.500000,307.000000  "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1324.000000,140.500000  C1322.841919,151.484985 1323.637573,162.500748 1323.541870,173.500366  C1323.386597,191.332336 1323.462402,209.166840 1323.538574,226.999832  C1323.550659,229.827240 1322.885742,232.722412 1324.000000,235.500000  "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M691.000000,92.500000  C689.869324,101.148125 690.567322,109.836052 690.567566,118.500000  C690.567749,127.163956 689.868347,135.851883 691.000000,144.500000  "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M973.500000,127.000000  C972.053589,125.081306 969.959412,125.506393 968.000000,125.505028  C954.333313,125.495506 940.666687,125.500000 927.000000,125.500000  "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M549.000000,225.500000  C545.781128,227.955734 542.242432,225.983704 539.008972,225.821304  C527.998474,225.268250 516.998474,225.751678 506.000824,225.468185  C504.842285,225.438324 503.537018,226.074142 502.500000,225.000000  "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M886.000000,112.500000  C869.833313,112.500000 853.666626,112.523445 837.500122,112.464561  C835.842834,112.458519 834.077454,113.058701 832.500000,112.000000  "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1320.000000,195.000000  C1320.000000,207.833328 1320.033936,220.666840 1319.968140,233.499832  C1319.956543,235.755325 1320.202271,237.904785 1321.000000,240.000000  "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1285.000000,67.500000  C1271.666626,67.500000 1258.333252,67.474380 1245.000122,67.535858  C1243.510620,67.542725 1241.894531,66.884430 1240.500000,68.000000  "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M523.500000,295.500000  C491.833344,295.500000 460.166656,295.500000 428.500000,295.500000  C425.500000,295.500000 422.500000,295.500000 419.500000,295.500000  "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M693.500000,147.000000  C690.896729,147.781708 690.651489,149.235916 690.850952,152.010712  C691.867676,166.154190 691.961426,180.335587 690.970215,194.497910  C690.793579,197.021072 692.183777,198.701202 693.982544,200.727798  C691.558411,201.433365 691.441956,203.058029 691.456543,205.000320  C691.544189,216.666336 691.529053,228.333496 691.463867,239.999802  C691.455566,241.489548 692.115540,243.105438 691.000000,244.500000  "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9,
    d: " M1240.000000,71.750000  C1238.391357,70.344940 1236.449341,70.482498 1234.500000,70.487434  C1224.000000,70.514000 1213.482178,70.113541 1203.004517,70.597023  C1189.663208,71.212646 1176.333130,70.843529 1162.999756,70.973442  C1150.334351,71.096848 1137.666504,71.037109 1125.000122,70.975906  C1121.497681,70.958984 1118.076660,71.049736 1114.500000,73.754326  C1114.500000,69.013809 1114.500000,65.006905 1114.500000,61.000000  "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M466.500000,323.500000  C453.500000,323.500000 440.499908,323.523102 427.500153,323.464813  C426.178345,323.458893 424.721924,324.058014 423.500000,323.000000  "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1285.500000,52.500000  C1285.500000,99.500000 1285.494263,146.500000 1285.524658,193.499985  C1285.525757,195.075394 1286.104858,196.792114 1283.500000,196.500000  "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M960.500000,305.000000  C959.037842,306.687469 957.136353,307.024445 955.000000,307.021606  C929.833313,306.987976 904.666687,307.000000 879.500000,307.000000  "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M246.000000,161.000000  C247.000000,161.000000 248.718521,160.671951 248.891022,161.049759  C251.087708,165.861053 255.344894,164.352005 259.000946,164.470535  C262.998505,164.600128 267.003479,164.500000 270.759613,164.500000  C272.131500,163.021133 270.650269,161.177521 272.390869,160.144928  C268.883789,157.495575 265.218872,159.206131 262.005737,159.273544  C258.227325,159.352829 254.143280,157.481140 250.500000,160.000000  "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M901.000000,114.500000  C913.500000,114.500000 926.000122,114.523964 938.499817,114.464745  C939.821716,114.458488 941.278076,115.058014 942.500000,114.000000  "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1046.500000,125.000000  C1032.833374,124.174477 1019.166687,124.174477 1005.500000,125.000000  "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1046.500000,114.000000  C1032.833374,114.825523 1019.166687,114.825523 1005.500000,114.000000  "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1046.500000,113.000000  C1032.833374,112.174477 1019.166687,112.174477 1005.500000,113.000000  "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1046.500000,126.000000  C1032.833374,126.825523 1019.166687,126.825523 1005.500000,126.000000  "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M901.500000,112.500000  C913.833313,112.500000 926.166809,112.475723 938.499817,112.535278  C939.821716,112.541664 941.278076,111.941986 942.500000,113.000000  "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M684.500000,21.500000  C670.851990,23.197552 657.177307,22.707611 643.500000,22.000000  "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M542.000000,255.000000  C541.021912,257.275360 541.581360,259.665802 541.519165,262.000519  C541.150696,275.830841 542.156982,289.678589 541.000000,303.500000  "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M770.000000,307.000000  C805.833313,307.000000 841.666687,307.000000 877.500000,307.000000  "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M909.500000,293.500000  C921.500000,293.500000 933.500854,293.414764 945.499634,293.536469  C951.362915,293.595917 956.634644,294.108673 959.756165,300.881958  C961.853027,305.431885 967.504456,306.703583 972.503296,306.926697  C979.156677,307.223633 985.835266,306.908569 992.498901,307.051453  C994.717468,307.098999 996.300171,306.033722 998.000000,305.000000  "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M472.500000,323.500000  C485.833344,323.500000 499.166656,323.500000 512.500000,323.500000  "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M293.500000,85.000000  C293.500000,116.166664 293.487640,147.333344 293.534546,178.499954  C293.537048,180.156677 292.941315,181.922531 294.000000,183.500000  "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M761.500000,234.000000  C761.500000,245.833328 761.486938,257.666687 761.504395,269.500000  C761.516907,277.957581 760.758606,286.267426 758.656860,294.539856  C757.592712,298.728516 758.166626,303.333344 758.000000,307.750000  "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M218.000000,78.000000  C221.936676,79.692741 224.464432,81.952057 221.505905,86.503838  C220.205627,88.504379 220.505615,90.787971 220.505020,93.000000  C220.497406,120.833336 220.513840,148.666702 220.465347,176.499939  C220.462463,178.156738 221.058701,179.922531 220.000000,181.500000  "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M690.500000,148.500000  C674.841309,147.581299 659.181213,146.796890 643.500000,148.000000  "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M526.000000,254.000000  C524.983582,255.327866 524.440369,256.708221 524.451050,258.500305  C524.537903,273.166443 524.496704,287.833344 524.520935,302.499969  C524.521484,302.833588 524.833313,303.166656 525.000000,303.500000  "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1002.000000,305.000000  C1004.942383,306.732117 1008.125854,307.049347 1011.500122,307.041595  C1042.333252,306.970795 1073.166626,306.990692 1104.000000,307.021454  C1106.000122,307.023438 1108.000000,307.333313 1110.000000,307.499969  "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M1114.000000,72.000000  C1111.564453,71.183357 1109.083496,70.832443 1106.499146,70.984543  C1096.841431,71.552902 1087.119263,71.232590 1077.488770,71.419243  C1067.103027,71.620529 1056.496094,71.663948 1045.994385,71.106155  C1038.740601,70.720886 1031.689941,71.416397 1024.369141,68.877380  C1018.864563,66.968246 1012.165649,68.432823 1006.000366,68.525879  C1002.454834,68.579384 998.700256,67.330894 995.483643,69.980110  C995.103882,70.292847 994.354736,70.624252 994.021179,70.457657  C984.498474,65.701477 974.335693,68.682541 964.493469,68.112808  C955.357422,67.583961 946.166077,67.936089 937.000244,68.026512  C932.299683,68.072876 927.252014,66.879837 923.056213,69.587097  C917.657349,73.070541 914.371460,66.975372 909.486816,67.304672  C900.365967,67.919571 891.106445,67.490639 882.016846,67.886902  C872.839905,68.286972 863.665405,68.197098 854.498352,68.437637  C844.172180,68.708588 833.833191,68.474037 823.500122,68.526314  C821.835449,68.534729 820.086243,68.029015 818.500000,69.000000  "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1110.000000,309.000000  C1110.384644,305.823883 1112.891479,307.086121 1114.500977,307.059204  C1122.332153,306.928131 1130.166626,307.000000 1138.000000,307.000000  C1167.500000,307.000000 1197.000000,307.000000 1226.500000,307.000000  "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M712.500000,223.500000  C712.500000,232.833328 712.546997,242.167068 712.467590,251.499725  C712.447205,253.891418 713.076111,256.348785 711.126953,258.609436  C710.420593,259.428589 710.851501,261.603119 711.302917,262.982697  C713.635010,270.110016 713.549072,277.267365 712.007080,284.501526  C711.471313,287.015106 711.138611,289.508636 714.000000,291.000000  "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M742.500000,223.500000  C742.500000,233.333328 743.327698,243.260025 742.232605,252.969833  C741.388428,260.454437 742.836548,267.666138 742.507568,275.000336  C742.419739,276.957489 742.918701,279.053589 741.000000,280.500000  "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,104.500000  C787.500000,104.500000 797.500061,104.482033 807.500000,104.510208  C810.791626,104.519478 814.227234,103.816460 817.046387,106.450348  C817.431091,106.809738 818.556641,106.668259 818.500000,105.500000  "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,100.500000  C790.000000,100.500000 802.500000,100.500000 815.000000,100.500000  "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,273.500000  C790.000000,273.500000 802.500000,273.500000 815.000000,273.500000  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M440.500000,255.000000  C442.077454,256.058685 443.843262,255.462143 445.500061,255.465271  C471.666626,255.514709 497.833344,255.500000 524.000000,255.500000  "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,277.500000  C789.498108,277.804382 801.513306,276.876801 813.500000,278.000000  "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M744.000000,69.500000  C741.121887,81.400909 743.006592,93.500381 742.528931,105.501152  C742.350098,109.994034 742.909668,114.545097 742.420227,118.991219  C741.151367,130.517395 743.204529,142.000000 742.500000,153.500000  "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M566.250000,70.499992  C566.166626,70.666656 566.054810,70.825851 566.008545,71.002235  C565.967712,71.158211 566.000000,71.333336 566.000000,71.500000  C557.166687,69.187347 548.441895,69.548668 539.459534,71.291473  C534.012390,72.348358 528.242493,73.284439 522.471497,71.597519  C519.022949,70.589478 516.154968,71.662865 515.407715,75.984039  C515.159607,77.418579 513.833313,78.666656 513.000000,79.999992  "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M221.500000,148.500000  C245.166672,148.500000 268.833344,148.500000 292.500000,148.500000  "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M442.500000,83.500000  C448.061920,83.256767 449.466614,82.203545 447.937836,94.500000  C432.003479,94.500000 416.001740,94.500000 400.000000,94.500000  "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1286.000000,49.500000  C1297.164429,49.820057 1308.347900,48.857048 1319.500000,50.000000  "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M774.000000,69.500000  C771.356445,78.887184 772.887573,88.494522 772.520081,98.000778  C772.415588,100.704842 772.501465,103.371696 768.500000,102.500000  "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M564.000000,253.000000  C565.633484,251.033829 567.900269,251.420837 569.998840,251.523849  C586.823303,252.349854 603.638916,253.442398 620.499451,252.980118  C621.110657,252.963379 622.341858,253.596115 622.000000,252.000000  "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M747.500000,256.000000  C747.566040,266.334961 747.064636,276.679504 748.013611,286.998749  C748.075806,287.675018 748.333313,288.333344 748.500000,289.000000  "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.500000,69.000000  C769.500000,80.000000 769.500000,91.000000 769.500000,102.000000  "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M566.000000,72.000000  C566.841003,75.357033 566.344482,77.752953 563.142517,80.187416  C560.157471,82.456863 560.708191,87.010406 560.629822,90.502914  C560.315674,104.495865 560.500000,118.500000 560.500000,132.500000  C560.500000,147.000000 560.573364,161.500656 560.444702,175.999512  C560.415222,179.324280 562.164795,182.766571 560.000000,186.000000  "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M126.500000,71.000000  C120.166664,69.379623 113.795517,69.250275 107.524506,71.083809  C105.786110,71.592087 104.025093,71.773918 102.521416,71.411224  C93.145622,69.149689 83.935387,70.204788 74.459915,71.051262  C69.176193,71.523285 63.130405,70.476486 57.499786,69.501228  C53.851353,68.869286 49.830856,70.962616 46.500000,68.000000  "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M575.000000,103.500000  C577.240112,107.514130 575.963257,111.872177 575.888672,115.997986  C575.578430,133.165482 576.478333,150.331207 575.682251,167.508453  C575.469971,172.089722 575.782959,176.835129 576.000000,181.500000  "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M530.000000,135.500000  C530.837524,146.000000 530.807068,156.500000 530.000000,167.000000  "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M975.000000,113.500000  C964.500000,113.500000 954.000000,113.500000 943.500000,113.500000  "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1235.500000,78.500000  C1235.500000,100.667923 1235.500000,122.835838 1235.500000,144.831345  C1232.666626,145.302368 1230.333374,146.084549 1227.500000,144.769318  C1227.500000,131.837555 1227.500000,118.668777 1227.500000,105.500000  "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M747.000000,76.000000  C748.067200,86.485703 747.199829,97.002586 747.530457,107.499039  C747.582886,109.162216 746.941284,110.922539 748.000000,112.500000  "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M633.500000,239.500000  C646.668762,239.500000 659.837524,239.500000 672.917664,239.500000  C674.439453,230.258789 673.861755,226.359360 670.500000,225.349854  C670.500000,228.816666 670.500000,232.158325 670.500000,235.500000  "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,124.500000  C787.497742,124.802925 797.515869,123.879593 807.500000,125.000000  "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M54.000000,136.500000  C54.819881,146.500000 54.819881,156.500000 54.000000,166.500000  "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M687.000000,266.500000  C685.409119,271.888245 685.078796,277.250732 687.509399,282.495636  C689.621460,287.053131 687.960266,291.848083 688.500000,296.500000  "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,126.500000  C787.497742,126.197075 797.515869,127.120407 807.500000,126.000000  "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,112.500000  C787.497742,112.802925 797.515869,111.879593 807.500000,113.000000  "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M755.000000,309.500000  C754.833313,310.666656 754.559387,311.829468 754.517151,313.000610  C754.210754,321.499481 754.223511,321.387451 746.000610,321.533600  C738.667236,321.663971 731.312012,320.896271 724.000000,322.000000  "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M530.500000,105.000000  C530.500000,113.833336 530.549316,122.667252 530.443604,131.499329  C530.428711,132.737411 531.676392,135.211121 528.500000,134.750000  "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M777.500000,114.500000  C787.497742,114.197075 797.515869,115.120407 807.500000,114.000000  "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M54.000000,104.500000  C54.819881,114.500000 54.819881,124.500000 54.000000,134.500000  "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M753.000000,319.500000  C733.500000,319.500000 714.000000,319.500000 694.500000,319.500000  "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M209.500000,85.000000  C209.500000,88.009247 209.500000,91.018494 209.500000,94.500000  C188.666672,94.500000 168.333328,94.500000 146.992752,94.500000  C149.521835,91.306488 147.683136,88.217621 149.000000,85.500000  "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M491.500000,72.000000  C489.900055,70.133148 487.782715,69.963203 485.499878,69.975555  C475.166840,70.031464 464.833344,70.000000 454.500000,70.000000  C447.166656,70.000000 439.832397,69.931816 432.500488,70.034012  C429.619720,70.074158 426.610657,69.287445 423.931793,71.414101  C423.216156,71.982216 421.541992,71.830956 420.520325,71.446075  C414.068207,69.015472 407.541290,69.678810 401.003601,70.771576  C398.173065,71.244690 396.474884,69.369965 394.500000,68.000000  "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1056.000000,72.500000  C1054.294189,78.085938 1055.222168,83.827057 1055.003906,89.500145  C1054.805176,94.665672 1055.400269,99.857002 1054.500000,105.000000  "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M817.000000,72.500000  C815.294250,78.085938 816.222046,83.827057 816.003845,89.500145  C815.805237,94.665672 816.400269,99.857002 815.500000,105.000000  "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1226.500000,278.500000  C1227.052490,289.164215 1225.121704,299.944824 1228.000000,310.500000  "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M772.500000,223.500000  C772.500000,233.333328 773.295044,243.253204 772.237305,252.971405  C771.453735,260.170502 771.202026,267.417755 771.363647,274.491699  C771.490295,280.033875 769.121643,286.322632 773.812927,291.664307  C775.052429,293.075714 774.000000,296.500000 774.000000,299.000000  "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1200.000000,77.000000  C1209.315918,78.141533 1218.668213,77.233429 1228.000488,77.482178  C1231.997681,77.588722 1236.000000,77.500000 1240.284058,77.500000  C1240.532104,75.833336 1240.888306,74.166664 1240.000000,72.500000  "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M471.500000,296.500000  C471.500000,309.000000 471.500000,321.500000 471.500000,334.047272  C470.458557,335.043243 469.150635,334.221069 467.500000,334.663757  C467.500000,321.837708 467.500000,309.168854 467.500000,296.500000  "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M513.500000,296.500000  C513.500000,309.000000 513.500000,321.500000 513.500000,334.047272  C514.541443,335.043243 515.849365,334.221069 517.500000,334.663757  C517.500000,321.837708 517.500000,309.168854 517.500000,296.500000  "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1320.000000,123.000000  C1320.000000,142.333328 1320.000000,161.666672 1320.000000,181.000000  "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M972.000000,208.500000  C970.877686,215.644440 971.762146,222.835114 971.527771,230.000916  C971.454773,232.232193 972.672974,233.353745 975.000000,233.000000  "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M892.500000,183.500000  C892.500000,207.000000 892.492676,230.500000 892.516174,253.999985  C892.517761,255.625198 891.876465,257.541168 894.000000,258.500000  "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M739.000000,208.500000  C737.877686,215.644440 738.762268,222.835114 738.527893,230.000916  C738.454895,232.232208 739.672974,233.353745 742.000000,233.000000  "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M423.000000,296.500000  C422.833344,308.166656 422.575226,319.833313 422.572906,331.500000  C422.572388,333.999207 421.999298,334.999298 419.500000,334.500000  "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1131.500000,183.500000  C1131.500000,207.000000 1131.492554,230.500000 1131.515991,253.999985  C1131.517700,255.625198 1130.876465,257.541168 1133.000000,258.500000  "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M714.500000,81.000000  C709.886414,84.804939 710.383484,90.249168 711.197266,94.965965  C712.471497,102.351059 711.661804,109.669197 711.911438,117.003014  C712.029785,120.479332 713.043945,123.986298 711.125854,127.567421  C709.568481,130.475037 712.743774,133.296570 712.580505,136.504105  C712.292725,142.156128 712.500000,147.833328 712.500000,153.500000  "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M694.500000,321.500000  C703.163940,321.807465 711.851868,320.869324 720.500000,322.000000  "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1055.000000,208.000000  C1055.000000,214.333328 1055.086426,220.668472 1054.955078,226.999069  C1054.906494,229.341278 1056.465088,232.705673 1052.007080,233.083344  C1051.785522,233.102127 1051.525513,234.332611 1051.521973,235.000137  C1051.486328,241.833252 1051.438965,248.667816 1051.566895,255.498749  C1051.585938,256.507751 1052.500000,257.500000 1053.000000,258.500000  "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1055.000000,233.000000  C1055.000000,239.833328 1055.019531,246.666763 1054.986206,253.499939  C1054.977783,255.213638 1055.460327,257.058746 1054.000000,258.500000  "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1054.000000,132.500000  C1055.319214,133.780914 1054.994141,135.434128 1054.994995,137.000000  C1055.003418,151.000000 1055.036499,165.000259 1054.938721,178.999573  C1054.929688,180.282166 1056.325684,182.651001 1052.998413,182.595642  C1051.613892,182.572617 1051.485840,184.213028 1051.489990,185.500031  C1051.511475,192.166641 1051.471680,198.833633 1051.543701,205.499527  C1051.550903,206.169724 1052.166626,206.833344 1052.500000,207.500015  "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M160.500000,68.000000  C157.427399,69.970337 154.487732,70.758812 150.468384,70.249542  C143.414948,69.355850 136.165527,69.935677 129.001114,70.062622  C127.791634,70.084045 126.144402,70.477737 126.500000,72.500000  "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M815.000000,132.500000  C816.319214,133.780914 815.994202,135.434128 815.995178,137.000000  C816.003540,151.000000 816.036560,165.000259 815.938721,178.999573  C815.929749,180.282166 817.325684,182.651001 813.998413,182.595642  C812.613953,182.572601 812.485840,184.213028 812.489990,185.500031  C812.511414,192.166641 812.471558,198.833633 812.543701,205.499527  C812.550964,206.169708 813.166687,206.833328 813.500000,207.500000  "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M816.000000,233.000000  C816.000000,239.833328 816.019592,246.666763 815.986206,253.499939  C815.977844,255.213638 816.460388,257.058746 815.000000,258.500000  "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M816.000000,208.000000  C816.000000,214.333328 816.086426,220.668472 815.955017,226.999069  C815.906433,229.341278 817.464966,232.705627 813.007080,233.083328  C812.785461,233.102127 812.525330,234.332596 812.521851,235.000107  C812.486206,241.833252 812.438782,248.667816 812.566833,255.498749  C812.585754,256.507751 813.500000,257.500000 814.000000,258.500000  "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M506.000000,86.000000  C506.801270,87.603203 506.486237,89.325539 506.488251,91.000015  C506.507782,107.333328 506.496918,123.666664 506.504669,140.000000  C506.505463,141.679794 506.256317,143.391037 507.591034,145.275772  C509.333344,146.084549 511.666656,145.302368 514.092041,144.899170  C514.562134,142.166672 514.965881,139.333328 514.000000,136.500000  "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M48.000000,93.000000  C48.942783,95.106964 48.470516,97.332870 48.477638,99.500076  C48.521999,112.999931 48.520020,126.500046 48.490025,139.999985  C48.478230,145.309311 47.538795,145.992691 42.000000,145.000000  "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M709.000000,183.500000  C707.877686,190.644440 706.784180,198.584961 709.075928,204.787186  C711.317627,210.854065 710.485168,216.736298 712.000000,222.500000  "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M695.000000,207.000000  C695.000000,220.666672 695.000000,234.333328 695.000000,248.000000  C695.000000,258.000000 695.024170,268.000092 694.982544,277.999939  C694.972534,280.411469 694.931152,282.764771 697.000000,284.500000  "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M972.000000,183.500000  C970.877686,190.644440 969.784180,198.584961 972.075928,204.787186  C974.317627,210.854065 973.485168,216.736298 975.000000,222.500000  "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M33.500000,83.000000  C32.108288,84.141266 30.482224,83.173347 28.750000,83.606735  C28.750000,88.655914 28.750000,93.827957 28.750000,99.206902  C30.148613,99.440430 31.824306,99.720215 33.500000,100.000000  "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,183.500000  C767.877686,190.644440 766.784180,198.584976 769.075867,204.787216  C771.317566,210.854080 770.485168,216.736298 772.000000,222.500000  "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M739.000000,183.500000  C737.877686,190.644440 736.784180,198.584976 739.075867,204.787216  C741.317566,210.854080 740.485168,216.736298 742.000000,222.500000  "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M739.000000,158.500000  C737.840942,165.810776 738.821716,173.170197 738.500000,180.500000  C744.358826,188.071701 740.315735,196.855347 741.459167,205.005722  C741.593567,205.963486 741.166687,207.000000 741.000000,208.000000  "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M972.000000,158.500000  C970.840942,165.810776 971.821716,173.170197 971.500000,180.500000  C977.358826,188.071701 973.315674,196.855362 974.459106,205.005737  C974.593445,205.963501 974.166687,207.000000 974.000000,208.000000  "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,158.500000  C767.840942,165.810776 768.821716,173.170197 768.500000,180.500000  C774.358826,188.071701 770.315735,196.855347 771.459167,205.005722  C771.593506,205.963501 771.166626,207.000000 771.000000,208.000000  "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M885.500000,273.000000  C885.262573,267.335419 885.957336,261.643402 885.000244,256.000000  C878.345093,254.748901 877.468262,255.456284 877.497131,262.000000  C877.513306,265.666595 877.500000,269.333344 877.500000,273.000000  "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M739.000000,233.500000  C737.877686,240.644440 738.821655,247.837219 738.489685,254.999527  C738.422791,256.443054 739.377380,257.385895 740.000000,258.500000  "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M718.000000,228.500000  C716.866394,235.978516 717.796326,243.502655 717.518921,251.000702  C717.483398,251.960266 717.472656,253.022766 719.000000,253.022766  C720.527344,253.022766 720.437012,251.966995 720.493591,250.999619  C720.834290,245.171646 719.844971,239.305099 721.000000,233.500000  "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M690.500000,324.000000  C691.534729,325.895874 693.387573,325.719391 694.992859,325.456299  C702.483215,324.228668 710.002563,325.311279 717.503174,325.136963  C733.493713,324.765350 749.506653,324.696899 765.500000,325.500000  "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M718.000000,128.500000  C716.866394,135.978516 717.796326,143.502655 717.518921,151.000702  C717.483398,151.960266 717.472656,153.022797 719.000000,153.022797  C720.527344,153.022797 720.422424,151.966583 720.495667,150.999664  C720.785400,147.172043 719.900696,143.292786 721.000000,139.500000  "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M551.000000,254.000000  C535.500000,253.666656 520.000244,253.321808 504.499542,253.023285  C503.340179,253.000946 502.361115,252.750031 501.500000,252.000000  "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M895.000000,154.500000  C893.563354,156.742615 894.515564,159.160889 894.511780,161.500015  C894.488403,175.999985 894.505005,190.500015 894.478943,204.999969  C894.478088,205.500244 894.166626,205.999985 893.999939,206.499985  "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M771.000000,158.500000  C771.821411,166.666672 771.814209,174.833328 771.000000,183.000000  "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M555.500000,104.500000  C548.500000,104.500000 541.428650,105.121086 534.519836,104.327133  C527.464050,103.516266 520.462036,105.761391 513.500000,104.000000  "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M974.000000,158.500000  C974.821411,166.666672 974.814209,174.833328 974.000000,183.000000  "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M718.000000,153.500000  C716.866394,160.978516 717.796326,168.502655 717.518921,176.000702  C717.483459,176.960266 717.472656,178.022797 719.000000,178.022797  C720.527344,178.022797 720.516541,176.960266 720.481079,176.000702  C720.203674,168.502655 721.133606,160.978516 720.000000,153.500000  "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M741.000000,158.500000  C741.821411,166.666672 741.814209,174.833328 741.000000,183.000000  "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M711.000000,158.500000  C712.133606,165.978516 711.203674,173.502655 711.481018,181.000702  C711.516541,181.960266 711.527344,183.022797 710.000000,183.022797  C708.472656,183.022797 708.483459,181.960266 708.518982,181.000702  C708.796326,173.502655 707.866394,165.978516 709.000000,158.500000  "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M816.000000,183.000000  C816.000000,189.333328 816.086426,195.668472 815.955017,201.999069  C815.906433,204.341278 817.464966,207.705627 813.007080,208.083328  C812.785461,208.102112 812.500732,209.339554 812.525452,209.999054  C812.794067,217.163925 811.872925,224.356323 813.014221,231.497726  C813.070251,231.848755 813.333313,232.166672 813.500000,232.500000  "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1055.000000,183.000000  C1055.000000,189.333328 1055.086426,195.668472 1054.955078,201.999069  C1054.906494,204.341278 1056.465088,207.705658 1052.007080,208.083344  C1051.785522,208.102127 1051.500610,209.339554 1051.525391,209.999054  C1051.794067,217.163925 1050.872925,224.356323 1052.014282,231.497711  C1052.070435,231.848724 1052.333252,232.166687 1052.500000,232.500015  "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1134.000000,154.500000  C1132.563354,156.742615 1133.515503,159.160889 1133.511719,161.500015  C1133.488403,175.999985 1133.504883,190.500015 1133.478882,204.999969  C1133.478027,205.500259 1133.166626,206.000000 1133.000000,206.500000  "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M718.000000,203.500000  C716.866394,210.978516 717.796326,218.502655 717.518982,226.000702  C717.483459,226.960266 717.472656,228.022766 719.000000,228.022766  C720.527344,228.022766 720.516541,226.960266 720.481018,226.000702  C720.203674,218.502655 721.133606,210.978516 720.000000,203.500000  "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M276.500000,68.000000  C272.531494,70.390579 262.116058,71.944252 258.031403,70.416054  C256.612305,69.885101 255.321991,70.043404 253.999786,70.035545  C243.333496,69.972137 232.643066,69.559288 222.006897,70.128914  C212.157547,70.656395 202.325531,68.989655 192.487198,70.411400  C190.232452,70.737228 187.944626,69.435333 185.501328,69.402184  C181.754730,69.351357 179.627136,70.585892 179.502151,74.409286  C174.843246,74.944054 170.128937,73.776779 165.500000,75.000000  "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M813.000000,133.500000  C811.853577,139.472778 812.646057,145.501083 812.539429,151.500702  C812.385437,160.164642 812.484070,168.833389 812.513672,177.499954  C812.519531,179.213531 812.039612,181.058746 813.500000,182.500000  "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M739.000000,133.500000  C737.899841,140.310562 738.708618,147.168030 738.570190,154.001419  C738.543091,155.339783 737.295959,157.677094 740.005310,157.946518  C742.740845,158.218536 740.581055,155.236786 742.000000,154.500000  "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M972.000000,133.500000  C970.899841,140.310562 971.708496,147.168015 971.570068,154.001419  C971.542969,155.339783 970.295959,157.677094 973.005310,157.946518  C975.740845,158.218536 973.581055,155.236786 975.000000,154.500000  "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1052.000000,133.500000  C1050.853516,139.472778 1051.645874,145.501083 1051.539307,151.500702  C1051.385376,160.164627 1051.484131,168.833389 1051.513794,177.499954  C1051.519653,179.213531 1051.039673,181.058746 1052.500000,182.500000  "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M720.000000,178.500000  C721.133606,185.978516 720.203674,193.502655 720.481018,201.000702  C720.516541,201.960266 720.527344,203.022797 719.000000,203.022797  C717.472656,203.022797 717.483459,201.960266 717.518982,201.000702  C717.796326,193.502655 716.866394,185.978516 718.000000,178.500000  "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M711.000000,183.500000  C711.821411,191.666672 711.814209,199.833328 711.000000,208.000000  "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M555.500000,100.500000  C542.000000,100.500000 528.500000,100.500000 515.000000,100.500000  "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M392.500000,68.000000  C391.157959,69.478233 389.489319,70.219574 387.501373,69.988174  C382.012756,69.349297 376.362640,69.633957 371.017883,69.883415  C360.678894,70.365974 350.334808,69.284943 339.969330,70.485130  C335.358185,71.019035 330.343445,70.019913 325.499969,70.007629  C315.500031,69.982277 305.500000,69.997032 295.500000,70.001472  C291.500000,70.003242 287.542725,70.922691 283.481049,70.092751  C281.595551,69.707474 279.842041,69.478233 278.500000,68.000000  "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M892.500000,158.500000  C892.500000,166.500000 892.500000,174.500000 892.500000,182.500000  "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1131.500000,158.500000  C1131.500000,166.500000 1131.500000,174.500000 1131.500000,182.500000  "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M601.500000,315.500000  C601.500000,321.666656 601.500000,327.833344 601.500000,334.047272  C602.541443,335.043243 603.849365,334.221069 605.500000,334.663757  C605.500000,328.175446 605.500000,321.837708 605.500000,315.500000  "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M396.000000,225.500000  C394.046478,233.500000 393.390228,241.500000 396.000000,249.500000  "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M894.000000,132.000000  C891.598389,132.620239 892.560608,134.593353 892.542542,136.000549  C892.450439,143.166031 892.500000,150.333328 892.500000,157.500000  "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M583.500000,315.500000  C583.500000,321.666656 583.500000,327.833344 583.500000,334.047272  C584.541443,335.043243 585.849365,334.221069 587.500000,334.663757  C587.500000,328.175446 587.500000,321.837708 587.500000,315.500000  "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M978.500000,80.500000  C978.551453,82.144005 980.619080,81.267845 980.500000,82.491241  C980.500000,91.994164 980.431396,101.497787 980.529968,110.999687  C980.576660,115.499474 979.806396,120.038033 981.000000,124.500000  "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1133.000000,132.000000  C1130.598389,132.620239 1131.560547,134.593353 1131.542480,136.000549  C1131.450439,143.166031 1131.500000,150.333328 1131.500000,157.500000  "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M708.500000,233.000000  C708.792297,240.830658 707.889221,248.686752 709.000000,256.500000  "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M514.500000,105.500000  C514.473694,115.510231 514.754700,125.530716 513.732971,136.000000  C511.513763,136.000000 509.506866,136.000000 507.500000,136.000000  "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M40.000000,105.000000  C41.168919,106.860733 41.006283,108.937996 41.005119,111.000000  C40.995918,127.333336 41.000000,143.666672 41.000000,160.000000  C41.000000,167.166672 41.000000,174.333328 41.000000,181.500000  "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,208.500000  C767.844971,214.305099 768.645874,220.168030 768.542175,226.000748  C768.382141,234.997910 768.523438,244.000107 768.481873,252.999924  C768.472595,255.006363 768.506775,256.937531 770.000000,258.500000  "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M972.000000,233.500000  C971.178284,241.166672 971.178284,248.833328 972.000000,256.500000  "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M709.000000,208.500000  C707.895752,214.139099 708.792969,219.837128 708.497986,225.499893  C708.402161,227.339188 708.843384,229.228180 708.000000,231.000000  "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M43.500000,65.500000  C39.011497,66.673431 39.013802,70.557365 38.560188,74.007912  C38.313564,75.883942 38.681629,77.840775 38.767525,79.657158  C40.832806,80.501228 42.666405,81.250618 44.500000,82.000000  "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M717.500000,81.000000  C717.287598,94.666107 717.898071,108.335289 717.216309,122.010780  C717.123108,123.879539 715.873962,127.569077 719.963928,128.638107  C721.253174,128.975082 720.231812,131.179352 720.500000,132.500000  C720.768188,133.820648 719.942017,135.278091 721.000000,136.500000  "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M720.000000,253.500000  C721.104675,259.641327 720.087769,265.845825 720.567200,271.994751  C720.719177,273.943878 718.972717,273.139404 718.500000,274.000000  "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1227.500000,78.500000  C1227.500000,85.666664 1227.500000,92.833336 1227.500000,100.000000  "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1127.500000,125.500000  C1131.033569,125.326324 1133.234863,125.354431 1133.799683,130.466888  C1134.652954,138.187927 1134.070190,145.837524 1134.500000,153.500000  "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M888.500000,125.500000  C892.033630,125.326324 894.234863,125.354439 894.799744,130.466888  C895.652832,138.187943 895.070129,145.837524 895.500000,153.500000  "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M542.500000,295.500000  C550.166687,295.500000 557.833313,295.500000 565.500000,295.500000  "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M620.500000,251.000000  C619.219055,249.680801 617.565918,250.007446 616.000000,250.005020  C608.666687,249.993668 601.333313,249.997421 594.000000,250.001846  C592.187378,250.002945 590.273438,249.689255 589.000000,251.500000  "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M741.500000,113.500000  C734.833313,113.500000 728.166687,113.500000 721.500000,113.500000  "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M771.000000,103.500000  C771.767395,110.833336 771.952759,118.194496 770.848206,125.476974  C770.621826,126.969177 770.702759,128.359055 771.088745,129.469131  C773.838257,137.376007 771.751770,145.515518 772.500000,153.500000  "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M561.500000,323.500000  C554.837463,323.168427 548.141724,324.164307 541.500000,323.000000  "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M465.500000,84.000000  C465.500000,87.341660 465.500000,90.683319 465.500000,94.500000  C474.666656,94.500000 483.333344,94.500000 492.500000,94.500000  C492.500000,90.683319 492.500000,87.341660 492.500000,84.000000  "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M355.500000,75.500000  C356.757324,76.106232 358.321411,76.802605 357.438721,78.467506  C356.291107,80.632141 354.974304,82.973427 351.999939,82.985413  C342.333435,83.024391 332.665192,82.908195 323.000977,83.061966  C320.457031,83.102440 319.999512,80.445251 318.000000,80.000000  "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M226.500000,83.500000  C226.500000,87.007935 226.500000,90.515862 226.500000,94.500000  C242.496414,94.500000 257.998199,94.500000 273.500000,94.500000  "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1226.500000,327.500000  C1226.500000,334.588562 1227.278809,335.263550 1233.790527,334.039398  C1234.715698,331.875580 1234.468628,329.677063 1234.500000,327.500000  "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M79.000000,80.000000  C81.446495,82.660522 84.481117,83.174789 88.002098,83.071571  C95.828705,82.842110 103.687347,82.669914 111.490051,83.158783  C114.713531,83.360733 116.209686,81.386314 117.873535,79.861961  C119.201065,78.645721 119.069817,76.310059 116.500000,75.500000  "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M820.000000,75.000000  C820.166687,81.500000 820.291321,88.001511 820.525085,94.499100  C820.597046,96.499336 819.950745,98.573547 821.000000,100.500000  "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M528.500000,166.750000  C530.895386,167.078018 530.564636,168.879639 530.493713,170.499725  C530.260254,175.833771 530.000000,181.166672 529.750000,186.500000  "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M740.500000,127.000000  C738.723511,124.809120 736.245117,125.564697 733.999573,125.522453  C729.834351,125.444084 725.666687,125.500000 721.500000,125.500000  "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M647.500000,325.000000  C641.224792,326.437988 634.775208,324.562012 628.500000,326.000000  "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M708.000000,139.500000  C709.096985,144.301254 708.122314,149.178421 708.551575,153.995407  C708.674438,155.373703 707.295959,157.677109 710.005310,157.946518  C712.740845,158.218552 710.581055,155.236786 712.000000,154.500000  "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M557.000000,188.500000  C555.978027,190.666672 556.769409,192.833328 556.364502,195.250000  C558.833313,195.250000 560.666687,195.250000 563.125977,195.250000  C562.701416,192.805023 563.700989,190.548645 562.000000,188.500000  "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M528.000000,188.500000  C526.299011,190.548645 527.298584,192.805023 526.874023,195.250000  C529.333313,195.250000 531.166687,195.250000 533.635498,195.250000  C533.230591,192.833328 534.021973,190.666672 533.000000,188.500000  "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M670.500000,218.000000  C673.500000,217.003250 673.500000,217.003250 673.500000,209.459641  C670.666687,209.704880 667.833313,209.017136 665.000000,210.000000  "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1110.500000,327.500000  C1110.500000,328.833344 1110.315552,330.198914 1110.541870,331.492676  C1110.910400,333.599396 1112.297363,334.534912 1114.500000,334.534912  C1116.702637,334.534912 1118.089478,333.599396 1118.458130,331.492676  C1118.684448,330.198914 1118.500000,328.833344 1118.500000,327.500000  "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M99.500000,74.000000  C93.563850,75.482582 87.436150,73.517418 81.500000,75.000000  "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M718.000000,253.500000  C716.586792,259.800537 717.298767,266.198425 717.689697,272.488220  C717.897522,275.832489 716.277893,279.244446 718.000000,282.500000  "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M460.500000,100.500000  C473.666656,100.500000 486.833344,100.500000 500.000000,100.500000  "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M576.000000,83.500000  C576.691528,89.556938 577.339233,95.611443 575.000000,101.500000  "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M624.500000,296.500000  C624.188477,302.495972 625.146423,308.527222 624.000000,314.500000  "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M129.500000,85.000000  C129.500000,88.009247 129.500000,91.018494 129.500000,94.500000  C108.666664,94.500000 88.333336,94.500000 66.992760,94.500000  C69.521828,91.306488 67.683144,88.217621 69.000000,85.500000  "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M162.500000,68.000000  C164.235214,70.068871 166.590836,69.996040 168.999557,70.030602  C172.682800,70.083443 176.447083,69.415421 180.000000,71.000000  "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M368.500000,85.000000  C368.500000,88.009247 368.500000,91.018494 368.500000,94.500000  C347.666656,94.500000 327.333344,94.500000 305.992767,94.500000  C308.521820,91.306488 306.683136,88.217621 308.000000,85.500000  "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M980.500000,256.000000  C980.500000,271.000000 980.500000,286.000000 980.500000,301.152985  C978.739258,301.773804 977.050537,301.827972 975.500000,300.500000  "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M658.500000,238.500000  C658.500000,237.333328 658.500000,236.166672 658.500000,234.750000  C655.350708,234.750000 652.175415,234.750000 648.735046,234.750000  C648.009460,235.908463 648.716858,237.505569 648.500000,239.000000  "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M498.000000,188.500000  C496.299042,190.548645 497.298615,192.805023 496.873993,195.250000  C499.333344,195.250000 501.166656,195.250000 503.554535,195.250000  C503.298431,193.166672 504.018738,191.333328 503.000000,189.500000  "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M569.000000,85.000000  C567.907715,91.643524 568.740356,98.334747 568.521545,105.000710  C568.401245,108.663422 568.487305,112.333389 568.503052,115.999985  C568.525757,121.278427 569.462708,121.992416 575.000000,121.000000  "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M911.000000,127.500000  C910.819519,133.266327 911.076965,138.981140 913.000000,144.500000  "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M460.500000,104.500000  C466.166656,104.500000 471.833344,104.500000 477.500000,104.500000  "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M223.500000,83.000000  C227.863693,82.763100 232.233902,83.506668 236.548386,81.610077  C239.673965,80.236099 242.632156,83.198906 246.002930,83.093254  C254.827576,82.816681 263.666656,83.000000 272.500000,83.000000  "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M695.000000,81.500000  C697.816040,83.103798 700.896973,83.016769 703.999817,83.032768  C706.521851,83.045769 709.168518,82.402695 711.500000,84.000000  "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M483.500000,104.500000  C489.000000,104.500000 494.500000,104.500000 500.000000,104.500000  "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M135.000000,189.500000  C133.981262,191.333328 134.701569,193.166672 134.445480,195.250000  C136.653992,195.250000 138.319290,195.250000 140.550018,195.250000  C140.168976,193.500000 141.103668,191.500000 140.000000,189.500000  "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M337.000000,74.000000  C331.567413,75.445625 325.932495,73.552650 320.500000,75.000000  "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M694.500000,50.000000  C694.794312,55.496132 693.889404,61.028603 695.000000,66.500000  "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M417.000000,77.000000  C411.528351,78.102234 405.996277,77.210808 400.500000,77.500000  "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M908.500000,81.000000  C907.226501,79.525612 905.550781,79.458939 905.626587,81.495285  C905.806458,86.326729 904.318665,91.294113 906.500000,96.000000  "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M215.000000,189.500000  C213.956436,191.253616 214.786423,193.177551 214.398239,195.250000  C216.333328,195.250000 218.166672,195.250000 220.554520,195.250000  C220.298431,193.166672 221.018738,191.333328 220.000000,189.500000  "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M374.000000,189.500000  C372.981262,191.333328 373.701569,193.166672 373.445465,195.250000  C375.653992,195.250000 377.319305,195.250000 379.550018,195.250000  C379.168976,193.500000 380.103668,191.500000 379.000000,189.500000  "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1147.500000,81.000000  C1146.226440,79.525612 1144.550781,79.458939 1144.626465,81.495293  C1144.806274,86.326729 1143.318726,91.294113 1145.500000,96.000000  "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M454.000000,189.500000  C452.956451,191.253616 453.786438,193.177551 453.398254,195.250000  C455.333344,195.250000 457.166656,195.250000 459.554535,195.250000  C459.298431,193.166672 460.018738,191.333328 459.000000,189.500000  "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M238.500000,74.000000  C234.731766,75.663902 230.831497,74.151489 226.994904,74.429756  C224.230621,74.630249 221.509140,74.659843 219.000000,76.000000  "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M567.500000,314.500000  C582.000000,314.500000 596.500000,314.508698 611.000000,314.488190  C612.674500,314.485809 614.396790,314.801270 616.000000,314.000000  "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.500000,290.500000  C769.382690,297.177460 770.038208,303.893585 768.500000,310.500000  "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M977.000000,69.000000  C974.343079,79.929588 976.232727,90.996864 975.980835,101.999565  C975.957886,103.002846 975.666626,103.999992 975.499939,104.999992  "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M808.500000,81.000000  C809.773499,79.525612 811.449280,79.458946 811.373413,81.495285  C811.193542,86.326729 812.681335,91.294113 810.500000,96.000000  "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1047.500000,81.000000  C1048.773560,79.525612 1050.449219,79.458939 1050.373535,81.495293  C1050.193726,86.326729 1051.681274,91.294113 1049.500000,96.000000  "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M697.500000,285.500000  C697.433716,289.412018 697.813904,293.236298 695.898865,297.074280  C694.488831,299.900146 695.332886,303.174133 698.000000,305.500000  "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1002.500000,273.000000  C1002.500000,268.666656 1002.424255,264.331573 1002.525085,260.000580  C1002.599670,256.795532 1001.197388,255.512650 998.001282,255.442444  C994.476624,255.365051 994.491638,257.576019 994.497253,260.000000  C994.507263,264.333313 994.500000,268.666656 994.500000,273.000000  "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M762.500000,95.000000  C761.801514,95.714233 760.877380,96.349869 761.012512,97.498528  C762.108582,106.817490 761.204346,116.168968 761.500000,125.500000  "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M690.000000,298.500000  C691.502197,303.833344 691.386292,309.166656 690.000000,314.500000  "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M912.500000,119.500000  C913.308899,123.642212 911.112976,124.718956 907.498840,124.521637  C905.338562,124.403694 903.166687,124.500000 901.000000,124.500000  "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M549.000000,223.500000  C547.853027,221.408737 548.878601,219.150360 548.313599,216.500000  C545.518494,216.500000 542.509277,216.500000 539.500000,216.500000  "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1017.500000,289.500000  C1012.382690,290.509979 1007.285156,291.724365 1002.000000,291.000000  "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M925.500000,93.000000  C926.684204,94.377136 928.053406,95.057587 930.000305,95.044693  C943.000305,94.958595 956.001099,95.000000 969.250000,95.000000  C969.250000,90.500000 969.250000,86.250000 969.250000,81.500000  C959.339050,81.500000 949.664490,81.311623 940.001892,81.570389  C934.170044,81.726555 928.236145,80.466240 922.500000,82.500000  "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M287.000000,85.500000  C288.480225,87.982872 286.307159,91.150742 289.222565,94.274765  C284.006348,93.838135 279.595032,96.399086 275.000000,94.000000  "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M260.500000,72.000000  C259.335876,72.636375 259.825684,74.842682 257.491211,74.577187  C252.857803,74.050217 248.134323,75.072357 243.500000,74.000000  "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M920.000000,71.500000  C919.185547,77.989243 922.518982,83.929535 922.380371,90.508018  C922.312500,93.729134 922.897278,97.527184 923.337158,101.020508  C924.110718,107.164536 922.929749,107.869728 916.220764,106.962227  C914.558777,103.166664 915.795471,99.333336 916.500000,95.500000  "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M54.000000,168.500000  C55.491272,173.422806 53.508728,178.577194 55.000000,183.500000  "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M567.500000,323.500000  C572.500000,323.500000 577.500000,323.500000 582.500000,323.500000  "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M544.000000,85.500000  C541.349060,84.616280 539.067932,83.016617 536.006226,82.870041  C531.467163,82.652725 530.733398,82.908730 530.495972,87.499794  C530.220337,92.830078 531.091797,98.195580 530.000000,103.500000  "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M871.500000,81.500000  C877.207275,81.142731 882.927673,80.563133 888.375000,82.425346  C888.375000,86.417763 888.375000,90.335014 888.375000,95.266312  C878.163025,93.895401 868.088135,94.915367 858.003906,94.994949  C848.357117,95.071075 838.649597,93.842949 829.000000,95.000000  "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M417.000000,75.000000  C412.241791,73.577499 407.256226,75.451492 402.500000,74.000000  "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M761.500000,326.000000  C761.500000,327.333344 761.557678,328.669647 761.488525,329.999390  C761.321838,333.203339 762.802612,334.487366 765.998718,334.557587  C769.523376,334.634979 769.519409,332.423950 769.500977,330.000000  C769.494629,329.166687 769.500000,328.333344 769.500000,327.500000  "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M193.500000,74.000000  C200.833328,74.976585 208.166672,74.726105 215.500000,74.000000  "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M887.000000,58.500000  C891.828857,58.204163 896.698730,59.096981 901.500000,58.000000  "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1128.000000,290.000000  C1114.500000,290.000000 1101.000000,290.000000 1087.500000,290.000000  "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1004.500000,125.500000  C996.833313,125.500000 989.166687,125.500000 981.500000,125.500000  "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M482.500000,101.500000  C482.500000,106.666664 482.357086,111.839417 482.576569,116.996742  C482.654663,118.832352 481.802032,119.423584 480.500000,120.000000  "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M478.500000,101.500000  C478.709442,107.498810 477.947815,113.524597 479.000000,119.500000  "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1133.000000,208.500000  C1134.450562,213.086868 1132.549438,217.913132 1134.000000,222.500000  "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M894.000000,208.500000  C895.450500,213.086868 893.549500,217.913132 895.000000,222.500000  "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M691.000000,48.500000  C690.184265,53.166668 690.184265,57.833332 691.000000,62.500000  "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M683.000000,149.000000  C682.029480,151.166672 682.744446,153.333328 682.241699,156.630707  C685.386353,153.628555 688.096375,156.612381 690.500000,155.000000  "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M680.500000,309.000000  C680.234497,313.663147 681.071472,318.365662 680.000000,323.000000  "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M691.000000,267.500000  C691.815735,272.166656 691.815735,276.833344 691.000000,281.500000  "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M913.500000,124.000000  C917.733643,125.363846 922.315002,123.714447 926.567261,124.916870  C926.558167,125.444580 926.549072,125.972290 926.539978,126.500000  C918.193359,126.500000 909.846680,126.500000 901.500000,126.500000  "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M994.000000,81.000000  C995.561279,85.666664 995.561279,90.333336 994.000000,95.000000  "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M770.500000,113.500000  C764.500000,113.500000 758.497314,113.607918 752.500977,113.459869  C748.854675,113.369850 745.904358,113.483177 747.465820,118.510612  C748.061157,120.427170 746.638672,122.599556 748.000000,124.500000  "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M561.500000,167.500000  C566.000000,167.500000 570.500000,167.500000 575.000000,167.500000  "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M561.500000,135.500000  C566.000000,135.500000 570.500000,135.500000 575.000000,135.500000  "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M618.000000,311.000000  C618.944763,318.649750 618.235107,326.335480 618.561707,334.106812  C619.544128,335.024292 620.844238,334.256927 622.000000,334.500000  "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M341.000000,74.000000  C345.418854,75.428741 350.081238,73.570107 354.500000,75.000000  "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M981.000000,114.500000  C988.495667,114.137711 996.024109,115.250565 1003.500000,114.000000  "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1129.000000,79.500000  C1128.170288,85.500000 1128.171631,91.500000 1129.000000,97.500000  "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M165.000000,60.500000  C164.494736,55.166668 166.105286,49.833332 165.201416,44.000000  C163.878021,44.000000 162.673706,44.122536 161.502960,43.976337  C158.366562,43.584682 157.456589,45.103962 157.443207,47.999737  C157.431702,50.493095 158.169266,53.066841 157.000000,55.500000  "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M568.000000,50.500000  C567.000000,50.500000 566.000000,50.500000 565.000000,50.500000  C565.000000,56.333332 565.000000,62.166668 565.000000,68.000000  "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M215.500000,84.500000  C211.800339,85.397659 208.278061,83.972046 205.052078,82.850243  C197.225250,80.128540 189.666672,84.372124 182.000000,83.000000  "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M388.000031,93.500000  C388.166687,92.166672 388.581085,90.810295 388.459595,89.503761  C387.704285,81.381584 393.044373,80.294807 398.433044,81.748222  C403.374603,83.081039 408.149323,82.667725 413.000000,83.000000  "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M509.500000,68.000000  C507.764771,70.068871 505.411041,70.127594 503.000000,70.000000  C500.588959,69.872421 498.235229,69.931129 496.500000,72.000000  "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1199.000000,80.000000  C1201.454468,83.121338 1205.216797,80.357597 1208.250000,82.127022  C1208.250000,86.250000 1208.250000,90.500000 1208.250000,94.505539  C1200.184937,96.553528 1192.333618,94.780807 1184.499146,94.960579  C1176.669800,95.140228 1168.778320,95.546974 1161.023560,94.766212  C1157.221069,94.383369 1153.673218,95.435493 1149.997314,95.024399  C1148.114014,94.813789 1146.677246,95.616966 1146.000000,97.500000  "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1112.500000,80.000000  C1108.103882,84.610390 1110.002075,89.850212 1111.000000,95.000000  "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1066.000000,79.500000  C1066.829712,85.500000 1066.828369,91.500000 1066.000000,97.500000  "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M998.000000,76.500000  C1000.328125,78.501732 1000.787659,81.015434 1000.573303,84.005257  C1000.336060,87.315613 1000.643921,90.667435 1000.757202,93.999756  C1000.846436,96.623604 999.877136,98.192123 997.000000,98.000000  "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M886.500000,68.500000  C886.500000,72.833336 886.500000,77.166664 886.500000,81.500000  "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M901.500000,104.500000  C905.833313,104.500000 910.166687,104.500000 914.500000,104.500000  "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M827.000000,79.500000  C828.032104,85.977806 827.919434,92.554474 827.295471,98.980133  C826.897949,103.073509 827.995544,106.826431 827.764465,111.000000  C828.999084,111.000000 829.999512,111.000000 831.000000,111.000000  "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M901.500000,100.500000  C905.833313,100.500000 910.166687,100.500000 914.500000,100.500000  "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M794.000000,69.000000  C794.000000,75.833336 793.980347,82.666763 794.013733,89.499931  C794.022095,91.213638 793.539612,93.058746 795.000000,94.500000  "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M981.500000,277.500000  C985.827576,277.816559 990.204163,276.858185 994.500000,278.000000  "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M789.500000,81.500000  C787.660950,81.500000 785.821838,81.500000 783.750000,81.500000  C783.750000,86.250000 783.750000,90.500000 783.750000,94.517006  C790.976562,96.800468 798.000610,94.211342 805.005371,94.949036  C807.108093,95.170479 809.129944,95.073441 810.000000,97.500000  "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M711.500000,232.500000  C706.333313,232.333344 701.166687,232.166672 696.000000,232.000000  "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M487.000000,249.500000  C484.285339,246.137390 480.548889,246.933212 477.576874,248.182861  C474.771393,249.362473 476.502991,252.619476 476.500000,255.000000  "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M562.000000,249.500000  C561.423584,248.197952 560.847900,247.172638 558.991089,247.437347  C557.030884,247.716782 555.000000,247.500000 553.000305,247.500061  C551.107971,248.854919 553.384277,251.043518 552.000000,252.500000  "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M981.500000,112.500000  C988.333313,112.500000 995.166687,112.500000 1002.000000,112.500000  "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M157.500000,105.500000  C157.500000,108.500000 157.541870,111.500702 157.491577,114.499855  C157.374405,121.487373 158.104599,122.135498 165.108063,120.982201  C166.344162,115.833336 164.493103,110.666664 165.000000,105.500000  "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1197.000122,72.499985  C1197.166748,73.333321 1197.733765,74.360878 1197.438232,74.969986  C1194.364868,81.305733 1196.209717,88.214317 1195.000000,94.750000  "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M729.000000,79.500000  C728.083191,80.499962 727.665222,81.263969 727.777161,83.014244  C728.018311,86.788170 729.093384,90.819717 727.000000,94.500000  "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1002.500000,327.500000  C1002.500000,328.666656 1002.560181,329.837067 1002.488098,330.999268  C1002.312866,333.824402 1000.507080,334.412048 998.003784,334.562500  C995.213684,334.730164 994.608765,333.202759 994.509277,330.999573  C994.456726,329.835297 994.500000,328.666656 994.500000,327.500000  "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,133.500000  C767.720642,140.975281 768.755249,148.501831 768.518250,156.000580  C768.487854,156.961044 768.471924,158.030884 770.000183,158.015945  C772.759277,157.988937 770.581055,155.236786 772.000000,154.500000  "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M799.500000,69.000000  C799.500000,73.339745 799.500000,77.679489 799.500000,82.325890  C802.465576,81.316917 804.990601,81.525856 807.500000,81.500000  "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M770.000000,127.000000  C762.873230,125.927910 755.727234,125.131447 748.500000,125.500000  "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1085.500000,294.000000  C1085.666626,294.166687 1085.806641,294.379944 1086.003906,294.493103  C1090.243530,296.925446 1106.062500,296.593811 1110.500000,293.670624  C1110.500000,298.320526 1110.500000,302.660248 1110.500000,307.000000  "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M885.000000,294.500000  C886.143433,299.833344 885.362915,305.166656 885.000000,310.500000  "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M311.500000,74.000000  C307.658478,75.617455 303.100586,72.936844 299.500000,76.000000  "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1187.500000,82.500000  C1187.500000,86.500000 1187.500000,90.500000 1187.500000,94.500000  "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1177.500000,82.500000  C1177.500000,86.500000 1177.500000,90.500000 1177.500000,94.500000  "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1166.500000,82.500000  C1166.500000,86.500000 1166.500000,90.500000 1166.500000,94.500000  "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1028.500000,82.500000  C1028.500000,86.500000 1028.500000,90.500000 1028.500000,94.500000  "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M948.500000,82.500000  C948.500000,86.500000 948.500000,90.500000 948.500000,94.500000  "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M938.500000,82.500000  C938.500000,86.500000 938.500000,90.500000 938.500000,94.500000  "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M588.500000,323.500000  C592.500000,323.500000 596.500000,323.500000 600.500000,323.500000  "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M472.500000,74.000000  C475.441589,74.380058 476.964111,75.656479 476.562012,79.007446  C475.985565,83.811600 475.833344,88.666664 475.500000,93.500000  "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M958.499939,69.000000  C958.333313,73.000000 958.166626,77.000000 957.999939,81.000000  "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M895.000000,289.500000  C891.038330,290.586517 886.995422,289.723083 883.000000,290.000000  "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M727.000000,81.500000  C725.612061,81.614983 724.048523,81.027328 722.769531,82.835915  C724.543396,86.399162 722.624451,90.586853 724.211060,95.117104  C726.911377,93.339752 729.456787,98.400848 732.500000,95.000000  "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M500.500000,251.500000  C496.500000,251.500000 492.500000,251.500000 488.500000,251.500000  "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1097.500000,82.500000  C1097.500000,86.333336 1097.500000,90.166664 1097.500000,94.000000  "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M858.500000,82.500000  C858.500000,86.333336 858.500000,90.166664 858.500000,94.000000  "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M397.500000,105.500000  C396.804993,110.663010 398.891235,116.184891 396.181946,121.187294  C394.163483,120.702545 393.775299,119.646423 393.500000,118.500000  "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M816.000000,107.000000  C814.992737,113.130241 817.342773,119.441948 815.000000,125.500000  "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M838.500061,69.500000  C838.666748,73.333328 838.833374,77.166664 839.000061,81.000000  "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1007.500000,82.500000  C1007.500000,86.333336 1007.500000,90.166664 1007.500000,94.000000  "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M801.000000,284.000000  C802.138062,289.973724 799.312378,295.557007 799.282776,301.498932  C799.262451,305.569641 796.112793,303.703796 793.917664,302.733673  C794.873535,299.708252 794.373657,296.835693 794.500000,294.000000  "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M389.500000,75.000000  C385.539124,73.866570 381.724731,74.417862 378.000000,76.000000  "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M881.000000,284.000000  C870.764099,281.486664 860.337524,282.881470 849.998779,282.536102  C843.320312,282.313019 836.698730,283.808319 830.267273,282.857086  C829.070618,285.608002 829.663330,287.833069 829.500000,290.000000  "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M273.500000,105.500000  C274.195007,110.663010 272.108765,116.184891 274.818054,121.187294  C276.836517,120.702545 277.224701,119.646423 277.500000,118.500000  "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1055.000000,107.000000  C1053.992798,113.130241 1056.342773,119.441948 1054.000000,125.500000  "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M53.500000,167.500000  C49.666668,167.500000 45.833332,167.500000 42.000000,167.500000  "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M878.500000,69.500000  C878.500000,77.666664 878.500000,85.833336 878.500000,94.000000  "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1085.000000,82.500000  C1085.831665,86.166664 1085.831665,89.833336 1085.000000,93.500000  "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1089.000000,82.500000  C1088.168335,86.166664 1088.168335,89.833336 1089.000000,93.500000  "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M808.000000,82.500000  C808.831604,86.166664 808.831604,89.833336 808.000000,93.500000  "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M707.000000,138.000000  C703.333313,138.000000 699.666687,138.000000 696.000000,138.000000  "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1106.000000,82.500000  C1106.831665,86.166664 1106.831665,89.833336 1106.000000,93.500000  "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M696.000000,194.500000  C696.831604,198.166672 696.831604,201.833328 696.000000,205.500000  "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1148.000000,82.500000  C1147.168335,86.166664 1147.168335,89.833336 1148.000000,93.500000  "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M357.500000,80.000000  C362.580719,83.713600 368.471344,84.367477 374.500000,84.500000  "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M846.500000,294.000000  C847.641663,295.472931 849.182861,295.908966 850.997986,296.030518  C856.367004,296.390045 856.809204,296.981323 856.507751,302.500427  C856.453308,303.497437 856.500000,304.500000 856.500000,305.500000  "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M118.500000,80.000000  C123.580711,83.713600 129.471359,84.367477 135.500000,84.500000  "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1319.000000,182.500000  C1318.168335,186.166672 1318.168335,189.833328 1319.000000,193.500000  "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M150.500000,74.000000  C146.963028,75.379990 142.793304,73.279816 139.500000,76.000000  "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1016.000000,82.500000  C1016.831604,86.166664 1016.831604,89.833336 1016.000000,93.500000  "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1002.500000,49.000000  C1002.227356,47.343933 1003.191589,45.564178 1001.772400,44.094398  C999.666687,43.253761 997.333313,43.253761 994.500000,44.384861  C994.500000,45.665318 994.500000,47.332661 994.500000,49.000000  "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1235.500000,49.000000  C1235.266113,47.340057 1236.139282,45.569408 1234.791748,44.050911  C1232.666626,43.697636 1230.333374,42.915451 1227.995605,43.998905  C1227.827393,45.666149 1227.663696,47.333073 1227.500000,49.000000  "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M801.000000,83.000000  C801.000000,86.666664 801.000000,90.333336 801.000000,94.000000  "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M790.000000,82.500000  C790.831604,86.166664 790.831604,89.833336 790.000000,93.500000  "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M846.000000,82.500000  C846.831604,86.166664 846.831604,89.833336 846.000000,93.500000  "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1047.000000,82.500000  C1047.831665,86.166664 1047.831665,89.833336 1047.000000,93.500000  "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M867.000000,82.500000  C867.831604,86.166664 867.831604,89.833336 867.000000,93.500000  "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M909.000000,82.500000  C908.168396,86.166664 908.168396,89.833336 909.000000,93.500000  "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1020.000000,82.500000  C1019.168396,86.166664 1019.168396,89.833336 1020.000000,93.500000  "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M915.500000,58.000000  C911.718506,58.929836 908.018066,58.968273 904.500000,57.000000  "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M850.000000,82.500000  C849.168396,86.166664 849.168396,89.833336 850.000000,93.500000  "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M606.500000,323.500000  C610.166687,323.500000 613.833313,323.500000 617.500000,323.500000  "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M871.000000,82.500000  C870.168396,86.166664 870.168396,89.833336 871.000000,93.500000  "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M721.000000,112.500000  C719.893066,110.233833 720.479309,107.809502 720.596313,105.504890  C720.690125,103.657936 719.419861,103.630775 718.500000,103.000000  "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M741.000000,288.500000  C744.349548,292.324707 741.410217,296.904114 742.765808,301.060547  C743.990417,301.227295 745.486084,301.430939 747.250000,301.671112  C747.250000,297.681152 747.250000,293.840576 747.250000,289.792389  C753.666687,288.862000 759.833435,290.073456 765.999939,289.995178  C767.723022,289.973297 769.539429,290.363953 771.000000,289.000000  "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M52.500000,102.499992  C48.333332,102.833328 44.167740,103.181389 39.998920,103.485176  C39.321812,103.534508 38.317268,103.857430 38.500000,102.500000  "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M878.500000,115.500000  C878.688721,121.687630 879.263733,122.109291 885.981689,121.003021  C887.389954,118.857368 885.379028,115.985977 887.500000,114.000000  "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M584.000000,142.000000  C584.981201,146.302002 584.347717,150.666107 584.525879,155.250000  C586.978760,155.250000 589.489319,155.250000 592.547791,155.250000  C592.255554,153.333328 592.970520,151.166672 592.000000,149.000000  "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M958.500000,290.000000  C966.500000,290.000000 974.500122,289.978180 982.499939,290.015778  C984.438721,290.024902 986.604736,289.393860 988.000000,291.500000  "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M165.500000,83.500000  C165.500000,87.000000 165.500000,90.500000 165.500000,94.000000  "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M472.500000,81.000000  C476.574524,80.439087 480.443359,82.346329 485.585693,80.955231  C482.212982,85.600243 483.165100,89.622986 483.000000,93.500000  "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M986.500000,290.000000  C986.500000,287.654755 986.500000,285.309509 986.500000,282.481873  C990.670837,282.669800 994.335449,282.834900 998.000000,283.000000  "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M285.000000,83.000000  C282.653839,83.884651 281.252533,81.118073 278.996307,81.476860  C276.943024,81.803383 274.549774,80.699043 272.999512,83.040016  C276.662781,88.563843 273.016998,94.342636 273.500000,100.000000  "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1077.000000,290.000000  C1067.833374,290.000000 1058.666626,290.000000 1049.500000,290.000000  "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M337.500000,83.500000  C337.500000,86.833336 337.500000,90.166664 337.500000,93.500000  "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M282.000000,84.500000  C280.085571,87.675224 281.391113,91.172447 281.000000,94.500000  "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1165.000000,291.500000  C1167.810059,288.741486 1171.362061,289.959290 1174.493408,290.125305  C1179.327881,290.381622 1184.430298,288.451813 1189.000000,291.500000  "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M44.500000,44.000000  C41.833405,43.222317 40.364597,43.917240 40.480114,47.000744  C40.687290,52.531136 40.741199,58.068981 42.000000,63.500000  "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M241.000000,71.500000  C240.111649,74.797249 240.639542,78.165314 240.500000,81.500000  "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M98.500000,83.500000  C98.500000,86.833336 98.500000,90.166664 98.500000,93.500000  "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1001.500000,95.000000  C1006.827942,95.557198 1012.414001,93.361809 1017.500000,96.500000  C1023.390869,93.282280 1029.857788,95.511749 1036.028442,94.722359  C1040.303955,94.175407 1045.401245,93.316643 1049.000000,97.500000  "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1067.500000,81.500000  C1073.166626,81.500000 1078.833374,81.500000 1084.500000,81.500000  "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M689.750000,246.000000  C689.333313,252.166672 688.916687,258.333344 688.500000,264.500000  "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M730.000000,308.000000  C730.671448,302.667267 728.644836,297.171631 731.850464,291.908936  C733.493164,289.212158 729.057129,284.849762 725.527405,285.624878  C724.085327,285.941559 721.999695,286.032776 721.250000,288.000000  "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1127.000000,95.000000  C1117.012329,94.092003 1106.947021,94.866005 1097.005981,94.988556  C1087.349609,95.107597 1077.649536,93.842949 1068.000000,95.000000  "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M721.000000,114.500000  C720.207581,117.833336 720.207581,121.166664 721.000000,124.500000  "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M828.500000,81.500000  C834.166687,81.500000 839.833313,81.500000 845.500000,81.500000  "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M990.500000,79.000000  C987.209167,80.898705 984.846191,83.044128 987.984070,87.012589  C989.640991,89.108047 987.437012,91.333336 988.095154,93.617783  C990.061218,96.050591 994.269348,93.693886 996.000000,97.000000  "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M72.500000,72.000000  C71.474731,73.326233 70.976875,74.978600 68.483307,74.614235  C65.819031,74.224930 62.860867,73.869072 60.500000,76.000000  "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1194.500000,81.500000  C1179.166626,81.500000 1163.833374,81.500000 1148.500000,81.500000  "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1118.500000,49.000000  C1118.123657,43.421429 1117.408569,42.944672 1110.500000,44.082336  C1110.500000,45.665318 1110.500000,47.332661 1110.500000,49.000000  "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1197.500000,296.000000  C1201.000977,296.000000 1204.501953,296.000000 1208.250000,296.000000  C1208.250000,291.500000 1208.250000,287.250000 1208.250000,282.625366  C1204.396362,282.245728 1200.912598,282.749329 1197.500000,284.000000  "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1068.000000,296.000000  C1071.166626,296.000000 1074.333374,296.000000 1077.500000,296.000000  "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1164.500000,294.000031  C1165.333374,294.666687 1166.181152,295.926392 1166.997681,295.906433  C1173.664429,295.743591 1180.348022,296.547333 1187.008057,295.554321  C1188.206299,295.375702 1188.883057,294.860687 1189.500000,294.000000  "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M918.500000,93.000000  C917.295898,95.397072 915.087463,95.008705 913.000000,95.006226  C910.662903,95.003456 908.096130,94.497452 907.000000,97.500000  "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M948.500000,283.500000  C948.500000,286.666656 948.500000,289.833344 948.500000,293.000000  "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M938.500000,283.500000  C938.500000,286.666656 938.500000,289.833344 938.500000,293.000000  "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M927.500000,283.500000  C927.500000,286.666656 927.500000,289.833344 927.500000,293.000000  "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M257.500000,84.000000  C257.500000,87.166664 257.500000,90.333336 257.500000,93.500000  "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1109.000000,284.000000  C1103.048828,280.841492 1096.658936,282.993286 1090.493164,282.610626  C1082.855225,282.136658 1075.166626,283.886963 1067.500000,282.500000  "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M389.999969,105.500000  C389.833313,109.666664 389.705170,113.835350 389.487213,117.999336  C389.325867,121.082077 390.833405,121.777687 393.500000,121.000000  "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M886.500000,49.000000  C886.283142,47.505577 886.990540,45.908459 886.121521,44.520996  C879.131592,43.313229 878.873108,43.468311 878.500000,49.000000  "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M571.500000,240.500000  C571.245422,243.662048 572.051636,246.879913 571.000000,250.000000  "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M393.500000,44.000000  C390.833405,43.222317 389.333710,43.917686 389.485840,47.000698  C389.707703,51.497974 389.833344,56.000000 390.000000,60.500000  "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1202.000000,113.500000  C1205.166626,113.500000 1208.333374,113.500000 1211.500000,113.500000  "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1127.500000,81.500000  C1124.333374,81.333328 1121.166626,81.166664 1118.000000,81.000000  "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M848.500000,290.000000  C853.833313,290.166656 859.171448,290.249207 864.497253,290.549011  C866.189087,290.644287 867.291626,289.833282 868.500000,289.000000  "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M711.000000,113.500000  C707.833313,113.500000 704.666687,113.500000 701.500000,113.500000  "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M259.500000,149.500000  C259.500000,152.666672 259.500000,155.833328 259.500000,159.000000  "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1028.500000,283.500000  C1028.500000,286.666656 1028.500000,289.833344 1028.500000,293.000000  "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M579.000000,72.500000  C576.002502,72.711601 572.953796,72.001656 570.000000,73.000000  "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M255.500000,149.500000  C255.500000,152.500000 255.500000,155.500000 255.500000,158.500000  "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M762.000000,128.500000  C760.944214,134.000000 761.808838,139.500000 761.416687,145.066391  C763.833313,144.809860 765.666687,146.407852 767.500000,145.000000  "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M561.500000,255.000000  C558.500000,255.830719 555.500000,255.830719 552.500000,255.000000  "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M976.500000,56.500000  C979.355591,58.132889 982.484314,57.308117 985.500000,57.500000  "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1285.500000,315.000000  C1285.500000,318.666656 1285.500000,322.333344 1285.500000,326.000000  "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1024.000000,247.500000  C1025.177246,250.500000 1025.177246,253.500000 1024.000000,256.500000  "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M54.000000,91.500000  C54.830723,94.500000 54.830723,97.500000 54.000000,100.500000  "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1046.500000,81.500000  C1037.833374,81.500000 1029.166626,81.500000 1020.500000,81.500000  "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1127.500000,282.500000  C1123.906616,283.655914 1119.581055,281.590027 1116.500000,285.000000  "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M394.000000,85.500000  C395.153687,88.445168 394.176361,91.508720 394.500000,94.500000  "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M838.500000,284.500000  C838.500000,291.833344 838.500000,299.166656 838.500000,306.500000  "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M241.000000,85.500000  C239.846313,88.445168 240.823654,91.508720 240.500000,94.500000  "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M195.000000,85.500000  C196.153687,88.445168 195.176346,91.508720 195.500000,94.500000  "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M281.500000,105.500000  C281.500000,109.666664 281.415161,113.835632 281.528046,117.999237  C281.611633,121.082458 280.166595,121.777687 277.500000,121.000000  "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M572.000000,45.500000  C569.497131,44.042046 568.675171,44.286968 568.563110,47.002602  C568.446716,49.824265 568.833313,52.666668 569.000000,55.500000  "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M467.500000,74.000000  C464.629395,75.248940 461.099152,73.529457 458.500000,76.000000  "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M710.500000,127.000000  C707.862122,124.327248 704.508728,125.947678 701.500000,125.500000  "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M1046.500000,293.500000  C1038.500000,293.500000 1030.500000,293.500000 1022.500000,293.500000  "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1118.500000,115.500000  C1118.399536,117.539223 1119.082153,119.863205 1116.657593,121.061363  C1115.163452,120.702545 1114.775269,119.646423 1114.500000,118.500000  "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1002.500000,115.500000  C1002.127319,118.032005 1004.119751,122.284050 998.500000,121.000000  "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M994.500000,115.500000  C994.600464,117.539223 993.917847,119.863205 996.342407,121.061363  C997.836487,120.702545 998.224670,119.646423 998.500000,118.500000  "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M201.000000,85.500000  C199.885696,88.277588 200.787476,91.173775 200.500000,94.000000  "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M56.000000,75.500000  C52.391678,72.400047 50.275185,75.267410 48.000000,77.500000  "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1157.500000,72.500000  C1156.522827,79.480698 1157.196167,86.500702 1157.000000,93.500000  "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1038.000000,284.500000  C1038.000000,291.833344 1038.000000,299.166656 1038.000000,306.500000  "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M998.500000,281.500000  C998.364807,283.487427 999.507263,284.991882 1000.529846,286.479492  C1001.398071,287.742523 1001.997253,289.240448 1001.430847,290.468109  C999.089050,295.544159 1000.748413,300.469055 1001.405762,305.512268  C1001.766174,308.276917 1001.166626,311.166656 1001.000000,314.000000  "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M155.000000,85.500000  C156.114304,88.277588 155.212524,91.173775 155.500000,94.000000  "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M918.000000,284.500000  C918.166626,291.833344 918.333313,299.166656 918.500000,306.500000  "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M808.000000,292.500000  C810.951660,290.404572 810.669067,286.927917 809.764465,284.591156  C808.715698,281.881714 805.166687,282.462158 802.500305,282.514984  C796.499329,282.633850 790.500000,282.833344 784.500000,283.000031  "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1047.000000,292.500000  C1049.951660,290.404572 1048.798462,287.277832 1048.991211,284.499390  C1049.153931,282.154846 1047.354370,282.263794 1046.013306,282.560303  C1043.519165,283.111786 1040.806396,282.532135 1038.500000,284.000000  "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1156.000000,289.000000  C1153.777100,291.729553 1149.849976,289.630371 1147.500000,292.000000  "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1037.500000,72.500000  C1038.477173,79.480698 1037.803833,86.500702 1038.000000,93.500000  "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M42.000000,92.500000  C39.748150,94.770370 42.251850,98.229630 40.000000,100.500000  "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M687.000000,298.500000  C685.168945,303.833344 685.168945,309.166656 687.000000,314.500000  "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1110.500000,273.000000  C1110.500000,268.500000 1110.521240,263.999847 1110.491943,259.500061  C1110.474243,256.772369 1111.258545,255.373810 1114.500000,255.373810  C1117.741455,255.373810 1118.525757,256.772369 1118.508057,259.500061  C1118.478760,263.999847 1118.500000,268.500000 1118.500000,273.000000  "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M163.000000,77.000000  C163.000000,82.991890 163.000000,82.992371 169.000000,82.999695  C170.666672,83.001724 172.333328,83.000000 174.000000,83.000000  "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M831.000000,291.500000  C829.441162,289.235291 827.077393,290.064178 824.999512,290.027313  C820.167725,289.941620 815.333313,290.000000 810.500000,290.000000  "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M500.500000,83.500000  C495.307037,83.574020 490.130585,83.392746 485.000000,82.500000  "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M434.000000,86.500000  C435.063354,89.110626 434.224945,91.840111 434.500000,94.500000  "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M694.000000,311.500000  C692.769836,315.960602 694.036072,320.513672 693.500000,325.000000  "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M712.500000,311.000000  C709.889404,312.063354 707.159912,311.224945 704.500000,311.500000  "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M897.500000,69.000000  C894.452637,79.517876 896.954651,90.382584 895.500000,101.000000  "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M446.500000,74.000000  C439.833344,75.106392 433.166656,74.782089 426.500000,74.000000  "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M877.500000,327.500000  C877.839233,329.832489 876.718994,332.373474 878.344116,334.530853  C880.029663,334.431519 879.337708,333.252167 879.500000,332.500000  "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M556.500000,75.000000  C553.833313,74.214577 551.166687,74.214577 548.500000,75.000000  "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M768.000000,231.500000  C765.833191,231.832352 763.442810,230.711731 761.471252,232.379562  C761.568481,234.029678 762.747803,233.337692 763.500000,233.500000  "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M762.000000,316.500000  C760.346985,318.824036 762.447327,321.648529 761.000000,324.000000  "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M524.000000,85.500000  C522.349792,87.769951 524.907043,90.881409 522.500000,93.000000  "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M554.000000,85.500000  C552.349792,87.769951 554.907043,90.881409 552.500000,93.000000  "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1114.500000,307.500000  C1114.500000,310.000000 1114.500000,312.500000 1114.500000,315.000000  "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M65.000000,85.500000  C66.650230,87.769951 64.092964,90.881409 66.500000,93.000000  "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M415.000000,85.500000  C415.333344,88.000000 415.666687,90.500000 416.000000,93.000000  "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M145.000000,85.500000  C146.650223,87.769951 144.092957,90.881409 146.500000,93.000000  "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M176.000000,85.500000  C176.333328,88.000000 176.666656,90.500000 177.000000,93.000000  "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M180.000000,85.500000  C179.666672,88.000000 179.333328,90.500000 179.000000,93.000000  "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M291.000000,85.500000  C289.349762,87.769951 291.907043,90.881409 289.500000,93.000000  "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M304.000000,85.500000  C305.650238,87.769951 303.092957,90.881409 305.500000,93.000000  "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M384.000000,85.500000  C385.650238,87.769951 383.092957,90.881409 385.500000,93.000000  "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1105.500000,81.500000  C1100.166626,81.500000 1094.833374,81.500000 1089.500000,81.500000  "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1015.500000,81.500000  C1010.833313,81.500000 1006.166687,81.500000 1001.500000,81.500000  "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M866.500000,81.500000  C861.166687,81.500000 855.833313,81.500000 850.500000,81.500000  "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1115.500000,73.500000  C1114.442017,74.721916 1114.571899,76.793671 1115.109619,77.403252  C1119.597778,82.490593 1116.624268,88.506416 1117.500000,94.000000  "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M420.500000,72.000000  C418.095795,75.048904 416.580750,78.144600 420.000000,81.500000  "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1229.500000,116.500000  C1226.166626,116.500000 1222.833374,116.500000 1219.500000,116.500000  "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M711.000000,288.500000  C706.924866,290.954926 702.644104,288.268677 698.500000,289.000000  "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M994.000000,58.000000  C991.500000,58.146080 989.000000,59.265232 986.500000,58.000000  "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1077.500000,82.000000  C1077.500000,86.000000 1077.500000,90.000000 1077.500000,94.000000  "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M958.500000,82.000000  C958.666626,86.000000 958.833313,90.000000 959.000000,94.000000  "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M838.500000,82.000000  C838.500000,86.000000 838.500000,90.000000 838.500000,94.000000  "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1110.500000,278.500000  C1110.783813,280.824951 1109.893066,283.233826 1111.000000,285.500000  "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M892.500000,278.000000  C890.166687,277.184875 887.833313,277.184875 885.500000,278.000000  "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M106.500000,72.000000  C107.525269,73.326233 108.026131,75.107178 110.521484,74.607246  C112.061859,74.298630 113.922539,73.941299 115.500000,75.000000  "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M987.500000,100.500000  C989.824951,100.216148 992.233826,101.106964 994.500000,100.000000  "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1200.000000,82.500000  C1199.120728,86.166664 1199.305176,89.833336 1200.000000,93.500000  "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1110.500000,53.000000  C1110.915649,55.315552 1109.492798,57.762421 1111.000000,60.000000  "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M881.500000,281.500000  C881.833313,283.833344 882.274963,286.158691 882.447693,288.503845  C882.518616,289.467529 883.079224,290.694336 881.994141,291.492035  C875.995117,295.902435 878.286926,301.839844 878.982849,307.502106  C879.103882,308.487244 879.000000,309.500000 879.000000,310.500000  "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M314.000000,71.500000  C313.765350,72.450661 314.532440,72.875404 314.974731,73.517410  C316.220612,75.325813 318.884064,77.301086 317.326019,79.368904  C315.762909,81.443436 313.482239,83.938141 310.000000,83.000000  "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M75.000000,72.000000  C75.333336,72.500000 75.676285,72.993896 75.998268,73.501099  C77.176186,75.356575 79.884071,77.301086 78.326019,79.368912  C76.762924,81.443436 74.482246,83.938141 71.000000,83.000000  "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M882.000000,308.000000  C882.000000,310.416656 882.000000,312.833344 882.000000,315.250000  "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M160.500000,75.000000  C158.943024,73.736481 157.128250,75.050842 155.500000,74.283768  C155.500000,76.833336 155.500000,79.166664 155.500000,81.500000  "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M579.000000,64.000000  C574.500000,64.000000 570.000000,64.000000 565.500000,64.000000  "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1285.500000,307.500000  C1285.500000,309.666656 1285.500000,311.833344 1285.500000,314.000000  "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M151.000000,83.000000  C154.780746,82.096802 158.532150,80.968742 162.500000,81.500000  "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M761.500000,53.000000  C761.949402,55.144920 760.533752,57.433304 762.000000,59.500000  "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1066.000000,280.500000  C1066.830566,286.500000 1066.830322,292.500000 1066.000000,298.500000  "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1129.000000,280.500000  C1128.169434,286.500000 1128.169678,292.500000 1129.000000,298.500000  "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M783.500000,280.500000  C783.500000,283.666656 783.500000,286.833344 783.500000,290.000000  "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M572.500000,44.000000  C576.843018,44.267460 576.843018,44.267460 575.960327,50.793491  C573.691528,51.015041 571.256165,49.753391 569.000000,51.000000  "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M515.000000,93.500000  C513.650818,95.830162 515.654419,98.830879 513.500000,101.000000  "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1110.500000,115.500000  C1110.872681,118.031975 1108.880249,122.284088 1114.500000,121.000000  "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1234.000000,317.500000  C1235.140625,319.591736 1234.176758,321.845367 1234.500000,324.000000  "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M471.999969,86.500000  C472.333313,88.666672 472.666656,90.833336 472.999969,93.000000  "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M419.000000,86.500000  C418.666656,88.666664 418.333313,90.833336 418.000000,93.000000  "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M878.500000,105.500000  C878.500000,107.666664 878.500000,109.833336 878.500000,112.000000  "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M886.500000,105.500000  C886.917358,107.988800 885.486328,110.724045 887.500000,113.000000  "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M994.500000,105.500000  C994.500000,107.666664 994.500000,109.833336 994.500000,112.000000  "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1002.500000,105.500000  C1002.917358,107.988800 1001.486328,110.724045 1003.500000,113.000000  "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1110.500000,105.500000  C1110.500000,107.666664 1110.500000,109.833336 1110.500000,112.000000  "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1118.500000,105.500000  C1118.500000,107.666664 1118.500000,109.833336 1118.500000,112.000000  "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1228.500000,136.500000  C1230.500000,136.500000 1232.500000,136.500000 1234.500000,136.500000  "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M235.000000,75.500000  C236.049225,77.426453 235.266373,79.505577 235.500000,81.500000  "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.500000,53.000000  C769.346069,55.001060 769.900940,57.061188 769.000000,59.000000  "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M281.000000,75.500000  C281.000000,77.500000 281.000000,79.500000 281.000000,81.500000  "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M440.000000,75.500000  C438.950775,77.426453 439.733612,79.505577 439.500000,81.500000  "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M878.500000,53.000000  C878.653931,55.001060 878.099060,57.061188 879.000000,59.000000  "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1227.500000,249.500000  C1229.500000,249.500000 1231.500000,249.500000 1233.500000,249.500000  "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M878.500000,265.500000  C880.500000,265.500000 882.500000,265.500000 884.500000,265.500000  "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M562.000000,102.500000  C566.166687,102.500000 570.333313,102.500000 574.500000,102.500000  "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1226.000000,318.000000  C1226.900879,319.938812 1226.346069,321.998932 1226.500000,324.000000  "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M995.500000,265.500000  C997.500000,265.500000 999.500000,265.500000 1001.500000,265.500000  "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M53.500000,135.500000  C49.666668,135.500000 45.833332,135.500000 42.000000,135.500000  "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M400.000000,71.500000  C399.833313,74.833336 399.666656,78.166664 399.500000,81.500000  "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1111.500000,265.500000  C1113.500000,265.500000 1115.500000,265.500000 1117.500000,265.500000  "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M134.500000,75.000000  C132.683670,73.564613 130.316330,75.435387 128.500000,74.000000  "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M273.500000,75.000000  C271.683685,73.564613 269.316315,75.435387 267.500000,74.000000  "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M518.500000,323.500000  C520.494446,323.266388 522.573547,324.049225 524.500000,323.000000  "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M47.500000,52.500000  C45.505581,52.733620 43.426453,51.950771 41.500000,53.000000  "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M507.500000,128.500000  C509.494415,128.733627 511.573547,127.950775 513.500000,129.000000  "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M158.500000,52.500000  C160.494415,52.733620 162.573547,51.950771 164.500000,53.000000  "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M274.500000,52.500000  C276.500000,52.500000 278.500000,52.500000 280.500000,52.500000  "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M396.500000,52.500000  C394.505585,52.733620 392.426453,51.950771 390.500000,53.000000  "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M195.500000,75.500000  C195.500000,77.500000 195.500000,79.500000 195.500000,81.500000  "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M200.500000,75.500000  C200.500000,77.500000 200.500000,79.500000 200.500000,81.500000  "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M434.500000,75.500000  C434.500000,77.500000 434.500000,79.500000 434.500000,81.500000  "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M507.500000,52.500000  C509.494415,52.733620 511.573547,51.950771 513.500000,53.000000  "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1228.500000,128.500000  C1230.500000,128.500000 1232.500000,128.500000 1234.500000,128.500000  "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1227.500000,53.000000  C1227.653931,55.001060 1227.099121,57.061188 1228.000000,59.000000  "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1097.500000,283.500000  C1097.500000,287.333344 1097.500000,291.166656 1097.500000,295.000000  "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1235.500000,53.000000  C1235.346069,55.001060 1235.900879,57.061188 1235.000000,59.000000  "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M777.000000,290.000000  C779.684143,290.406769 782.735291,288.856323 785.000000,291.500000  "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M61.000000,188.500000  C62.049229,190.426453 61.266380,192.505585 61.500000,194.500000  "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M55.000000,188.500000  C53.950771,190.426453 54.733620,192.505585 54.500000,194.500000  "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1002.500000,53.000000  C1002.346069,55.001060 1002.900940,57.061188 1002.000000,59.000000  "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M158.500000,112.500000  C160.494415,112.266380 162.573547,113.049225 164.500000,112.000000  "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M274.500000,112.500000  C276.500000,112.500000 278.500000,112.500000 280.500000,112.500000  "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M294.000000,188.500000  C292.950775,190.426453 293.733612,192.505585 293.500000,194.500000  "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M300.000000,188.500000  C301.049225,190.426453 300.266388,192.505585 300.500000,194.500000  "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M396.500000,112.500000  C394.505585,112.266380 392.426453,113.049225 390.500000,112.000000  "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1118.500000,53.000000  C1118.346069,55.001060 1118.900879,57.061188 1118.000000,59.000000  "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1177.500000,283.500000  C1177.500000,287.500000 1177.500000,291.500000 1177.500000,295.500000  "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M885.500000,327.500000  C885.468689,329.677063 885.715698,331.875580 884.593506,334.500000  C883.334656,334.500000 881.667358,334.500000 880.000000,334.500000  "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M877.000000,318.000000  C877.600220,319.833344 877.930115,321.666656 877.000000,323.500000  "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1145.500000,290.000000  C1142.000000,290.000000 1138.500000,290.000000 1135.000000,290.000000  "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M906.500000,290.000000  C903.000000,290.000000 899.500000,290.000000 896.000000,290.000000  "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1197.000000,284.500000  C1195.825806,291.833344 1197.222046,299.166656 1197.000000,306.500000  "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1077.500000,284.500000  C1077.617676,287.238342 1076.849731,290.156952 1079.011230,292.489594  C1079.691040,293.223206 1079.560669,293.708984 1079.032837,294.521301  C1076.614380,298.242340 1077.729248,302.466156 1077.500000,306.500000  "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M286.500000,74.000000  C282.954681,75.668045 279.071106,73.615334 275.500000,75.000000  "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M569.500000,112.500000  C571.333313,112.500000 573.166687,112.500000 575.000000,112.500000  "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M987.000000,95.500000  C984.550964,97.491096 986.692993,99.890244 986.674683,102.001511  C986.641235,105.871750 985.536255,107.820808 981.500000,107.500000  "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1132.500000,278.500000  C1134.783447,278.291565 1134.896240,280.379974 1134.902466,281.500549  C1134.937622,287.832764 1134.666626,294.166656 1134.500000,300.500000  "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M893.500000,278.500000  C895.783447,278.291565 895.896301,280.379944 895.902588,281.500549  C895.937744,287.832764 895.666687,294.166656 895.500000,300.500000  "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M42.000000,128.500000  C43.833332,128.500000 45.666668,128.500000 47.500000,128.500000  "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1321.000000,182.500000  C1321.947876,186.166672 1321.947876,189.833328 1321.000000,193.500000  "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M980.000000,76.000000  C980.826477,77.833336 980.826477,79.666664 980.000000,81.500000  "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1202.000000,125.500000  C1204.833374,125.500000 1207.666626,125.500000 1210.500000,125.500000  "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M729.500000,295.500000  C727.358337,295.318756 725.472717,295.841644 724.000000,297.500000  "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1161.500000,294.000000  C1155.922607,296.808563 1157.616821,301.944031 1157.500000,306.500000  "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M973.500000,278.500000  C976.005432,278.472321 976.137756,280.707458 975.893677,281.979614  C974.708618,288.157532 976.659546,294.360168 975.500000,300.500000  "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M762.500000,249.500000  C764.166687,249.500000 765.833313,249.500000 767.500000,249.500000  "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M762.500000,241.500000  C764.166687,241.500000 765.833313,241.500000 767.500000,241.500000  "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M719.500000,289.000000  C718.500000,290.000000 717.641846,291.621918 716.474487,291.888123  C712.292847,292.841797 712.733032,296.491516 713.719910,298.385437  C715.428528,301.664581 715.116211,305.417664 717.000000,308.500000  "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1118.500000,278.500000  C1118.333374,280.166656 1118.166626,281.833344 1118.000000,283.500000  "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M879.000000,95.000000  C878.833374,96.666672 878.666687,98.333336 878.500000,100.000000  "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M165.500000,95.000000  C165.500000,96.666664 165.500000,98.333336 165.500000,100.000000  "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1117.999878,95.000008  C1118.166626,96.666672 1118.333252,98.333344 1118.499878,100.000008  "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.500000,112.500000  C823.156311,112.229881 824.922546,113.058701 826.500000,112.000000  "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M481.500000,75.000000  C479.833344,74.206467 478.166656,74.206467 476.500000,75.000000  "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M762.500000,136.500000  C764.166687,136.500000 765.833313,136.500000 767.500000,136.500000  "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M387.000000,94.000000  C388.508423,93.822792 389.840088,93.749031 389.532440,96.004425  C389.353912,97.313408 389.500000,98.666664 389.500000,100.000000  "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M886.500000,53.000000  C886.088623,54.987000 887.504211,57.278477 885.500000,59.000000  "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M690.500000,22.999998  C688.833313,22.666664 687.166687,22.333330 685.500000,21.999998  "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M124.500000,74.000000  C122.896523,74.824646 120.825333,74.479996 119.500000,76.000000  "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1136.500000,72.000000  C1133.497681,79.162720 1135.295410,86.650970 1134.952759,93.997795  C1134.844116,96.327774 1135.532104,98.728477 1134.500000,101.000000  "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1207.500000,126.000000  C1207.500000,127.500000 1207.500000,129.000000 1207.500000,130.500000  "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M994.500000,53.000000  C994.941223,54.982018 993.420715,57.290989 995.500000,59.000000  "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M694.000000,194.500000  C693.666687,196.000000 693.333374,197.500000 693.000000,199.000000  "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M886.500000,95.500000  C886.500000,97.000000 886.500000,98.500000 886.500000,100.000000  "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M520.000000,223.500000  C521.500000,223.500000 523.000000,223.500000 524.500000,223.500000  "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M320.000000,85.500000  C319.036774,88.455750 319.761688,91.505280 319.500000,94.500000  "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M355.000000,85.500000  C355.963226,88.455750 355.238312,91.505280 355.500000,94.500000  "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M400.000000,85.500000  C400.290009,90.527016 397.936646,95.098267 397.500000,100.000000  "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1114.000000,292.500000  C1118.717773,296.199677 1117.692505,301.540222 1118.000000,306.500000  "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M157.500000,95.500000  C157.500000,97.000000 157.500000,98.500000 157.500000,100.000000  "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M81.000000,85.500000  C80.036789,88.455750 80.761703,91.505280 80.500000,94.500000  "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M116.000000,85.500000  C116.963211,88.455750 116.238297,91.505280 116.500000,94.500000  "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M161.000000,85.500000  C160.036789,88.455750 160.761703,91.505280 160.500000,94.500000  "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M281.000000,96.000000  C281.166656,97.333336 281.333313,98.666672 281.500000,100.000000  "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1110.500000,96.000000  C1110.500000,97.333336 1110.500000,98.666664 1110.500000,100.000000  "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M714.500000,304.000000  C712.395508,303.683044 712.464478,305.104919 712.500000,306.500000  "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1020.500000,295.000000  C1018.633545,297.140625 1015.873535,296.779205 1013.500000,297.500000  "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M432.500000,83.000000  C435.500000,80.750008 438.500000,80.750008 441.500000,83.000000  "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M799.000000,81.500000  C796.076660,82.863373 793.456482,79.073418 790.500000,81.000000  "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M76.000000,85.500000  C77.038208,88.282066 76.159729,91.176880 76.500000,94.000000  "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M121.000000,85.500000  C119.961792,88.282066 120.840271,91.176880 120.500000,94.000000  "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M235.000000,85.500000  C236.038208,88.282066 235.159729,91.176880 235.500000,94.000000  "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M315.000000,85.500000  C316.038208,88.282066 315.159729,91.176880 315.500000,94.000000  "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M244.000000,163.500000  C242.941986,164.721909 243.768204,166.179352 243.500000,167.500000  "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M360.000000,85.500000  C358.961792,88.282066 359.840271,91.176880 359.500000,94.000000  "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M440.000000,86.500000  C439.060394,88.948471 439.754791,91.505875 439.500000,94.000000  "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M520.500000,81.000000  C524.726929,77.548965 522.667297,82.899155 524.000000,83.500000  "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M550.500000,81.000000  C554.726929,77.548965 552.667297,82.899155 554.000000,83.500000  "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M990.000000,121.500000  C989.215210,124.166664 989.215210,126.833336 990.000000,129.500000  "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M693.500000,202.000000  C693.766174,203.152451 692.925842,204.462967 694.000000,205.500000  "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M995.500000,307.000000  C995.500000,308.166656 995.500000,309.333344 995.500000,310.500000  "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M626.500000,248.500000  C626.329224,250.328369 624.300537,249.927338 623.500000,251.000000  "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M765.500000,331.500000  C765.638000,333.723999 767.983032,331.533905 768.500000,333.000000  "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M287.500000,81.000000  C291.726929,77.548965 289.667267,82.899155 291.000000,83.500000  "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M645.500000,20.000000  C643.500000,20.656021 641.500000,20.656021 639.500000,20.000000  "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M645.500000,150.000000  C643.500000,149.343979 641.500000,149.343979 639.500000,150.000000  "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1210.500000,122.500000  C1210.910522,123.474274 1209.481201,125.061829 1211.500000,125.500000  "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M387.500000,81.000000  C386.333344,78.824600 385.166656,80.724754 384.000000,81.000000  "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M307.500000,81.000000  C306.333344,78.824600 305.166656,80.724754 304.000000,81.000000  "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M148.500000,81.000000  C147.333328,78.824600 146.166672,80.724754 145.000000,81.000000  "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M68.500000,81.000000  C67.333336,78.824600 66.166664,80.724754 65.000000,81.000000  "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1106.500000,81.000000  C1108.150513,78.629539 1109.194214,81.113014 1110.500000,81.500000  "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M529.500000,306.500000  C527.301392,309.113892 529.214661,312.211517 528.301880,315.250000  C531.313782,315.250000 534.156921,315.250000 537.250000,315.250000  C537.250000,312.686188 537.250000,309.843109 537.250000,306.500000  C535.022034,306.500000 532.510986,306.500000 530.000000,306.500000  "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M530.500000,303.500000  C528.819458,303.780090 527.138855,304.060181 525.250000,304.374969  C525.250000,310.500000 525.250000,316.500000 525.250000,322.750000  C530.500000,322.750000 535.500000,322.750000 540.750000,322.750000  C540.750000,316.500000 540.750000,310.500000 540.750000,304.595367  C537.430664,303.242157 534.197815,303.537170 531.000000,303.500000  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuga);
export default __webpack_public_path__ + "static/media/stuga.3425150134b2a8a4c04489caf3dd80ac.svg";
export { ForwardRef as ReactComponent };